// /**
//  * ============================================================================
//  * CART & WISHLIST SYNCHRONIZATION MODULE
//  * ============================================================================
//  * 
//  * A self-contained JavaScript module for syncing Shopify cart and wishlist
//  * actions with an external middleware API.
//  * 
//  * Features:
//  * - Intercepts all Shopify cart events (add, update, remove, wishlist)
//  * - Handles guest and logged-in user flows
//  * - Persistent browser/session identification
//  * - Automatic guest → user cart linking on login
//  * - Defensive error handling with exponential backoff retry
//  * - No external dependencies
//  * 
//  * Recent Fixes (v1.0.2):
//  * - Cross-device sync: Cart reloads automatically on first sync (no manual reload needed)
//  * - Duplicate prevention: __ZYDUS_SYNCING__ flag prevents duplicate UPDATE entries
//  * - Guest user fix: Skip API calls for guests (no more 422 errors)
//  * - Cart preservation: Guest cart items pushed to backend on login (no data loss)
//  * - URL matching: Only intercept Shopify endpoints, not middleware API (clean console)
//  * 
//  * @version 1.0.2
//  * @author Zydus Development Team
//  * ============================================================================
//  */

// (function () {
//     'use strict';

//     // ============================================================================
//     // IDEMPOTENT INITIALIZATION CHECK
//     // ============================================================================

//     // Prevent double-initialization if script is loaded multiple times
//     if (window.__ZYDUS_CART_SYNC_INITIALIZED__) {

//         return;
//     }
//     window.__ZYDUS_CART_SYNC_INITIALIZED__ = true;

//     // Initialize sync flag (prevents duplicate logging during cross-device sync)
//     window.__ZYDUS_SYNCING__ = false;



//     // ============================================================================
//     // CONFIGURATION
//     // ============================================================================

//     const CONFIG = {
//         // API Base URL - Zydus Middleware Server
//         API_BASE_URL: 'https://zydus.binaryic.in',

//         // API Endpoints
//         ENDPOINTS: {
//             CART_ACTION: '/api/cart/action',
//             UPDATE_BROWSER_ID: '/api/cart/update-browser-id',
//             GET_CART: '/api/cart/get',
//             REMOVE_SECURE: '/api/cart/remove-secure'
//         },

//         // Storage Keys
//         STORAGE_KEYS: {
//             BROWSER_ID: 'zydus_browser_id',
//             SESSION_ID: 'zydus_session_id',
//             GUEST_LINKED: 'zydus_guest_linked',
//             LAST_CUSTOMER_ID: 'zydus_last_customer_id',
//             CART_SYNCED: 'zydus_cart_synced',
//             SKU_CACHE: 'zydus_sku_cache_', // Prefix for caching SKUs by variant_id
//             LOGOUT_TIMESTAMP: 'zydus_logout_timestamp' // Track last logout time
//         },

//         // Deduplication - prevent duplicate API calls
//         DEDUP_WINDOW_MS: 1000, // 1 second window for deduplication

//         // Sync prevention - prevent syncing immediately after logout
//         LOGOUT_SYNC_DELAY_MS: 5000, // 5 seconds - don't sync if logged out recently

//         // Retry Configuration
//         RETRY: {
//             MAX_ATTEMPTS: 3,
//             BASE_DELAY_MS: 1000,
//             MAX_DELAY_MS: 10000
//         },

//         // Request Timeout (ms)
//         REQUEST_TIMEOUT: 15000,

//         // Debounce delay for rapid cart updates (ms)
//         DEBOUNCE_DELAY: 300
//     };

//     // ============================================================================
//     // UTILITY FUNCTIONS
//     // ============================================================================

//     /**
//      * Generates a cryptographically random UUID v4
//      * @returns {string} UUID string
//      */
//     function generateUUID() {
//         if (typeof crypto !== 'undefined' && crypto.randomUUID) {
//             return crypto.randomUUID();
//         }
//         // Fallback for older browsers
//         return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
//             const r = Math.random() * 16 | 0;
//             const v = c === 'x' ? r : (r & 0x3 | 0x8);
//             return v.toString(16);
//         });
//     }

//     /**
//      * Gets or creates a persistent browser ID (stored in localStorage)
//      * @returns {string} Browser ID
//      */
//     function getBrowserId() {
//         let browserId = null;
//         try {
//             browserId = localStorage.getItem(CONFIG.STORAGE_KEYS.BROWSER_ID);
//             if (!browserId) {
//                 browserId = 'browser_' + generateUUID();
//                 localStorage.setItem(CONFIG.STORAGE_KEYS.BROWSER_ID, browserId);
//             }
//         } catch (e) {
//             // localStorage not available, generate ephemeral ID
//             browserId = 'browser_' + generateUUID();

//         }
//         return browserId;
//     }

//     /**
//      * Gets or creates a session ID (stored in sessionStorage)
//      * @returns {string} Session ID
//      */
//     function getSessionId() {
//         let sessionId = null;
//         try {
//             sessionId = sessionStorage.getItem(CONFIG.STORAGE_KEYS.SESSION_ID);
//             if (!sessionId) {
//                 sessionId = 'session_' + generateUUID() + '_' + Date.now();
//                 sessionStorage.setItem(CONFIG.STORAGE_KEYS.SESSION_ID, sessionId);
//             }
//         } catch (e) {
//             // sessionStorage not available, generate ephemeral ID
//             sessionId = 'session_' + generateUUID() + '_' + Date.now();

//         }
//         return sessionId;
//     }

//     /**
//    * Safely retrieves customer data from Shopify global objects
//    * Priority: window.__ZYDUS_CUSTOMER__ (Liquid-injected) > other sources
//    * @returns {Object} Customer data object
//    */
//     function getCustomerData() {
//         const customer = {
//             id: null,
//             email: null,
//             phone: null,
//             name: null,
//             isLoggedIn: false
//         };

//         try {
//             // PRIMARY SOURCE: Zydus customer object injected by Liquid template
//             // This is the most reliable source as it comes directly from Shopify's Liquid
//             if (typeof window.__ZYDUS_CUSTOMER__ !== 'undefined' && window.__ZYDUS_CUSTOMER__ !== null) {
//                 const zydusCustomer = window.__ZYDUS_CUSTOMER__;
//                 customer.id = zydusCustomer.id || null;
//                 customer.email = zydusCustomer.email || null;
//                 customer.phone = zydusCustomer.phone || null;
//                 customer.name = zydusCustomer.name ||
//                     ((zydusCustomer.firstName || '') + ' ' + (zydusCustomer.lastName || '')).trim() ||
//                     null;
//                 customer.isLoggedIn = !!zydusCustomer.id;

//                 // If we have data from Liquid, return immediately
//                 if (customer.isLoggedIn) {

//                     return customer;
//                 }
//             }

//             // FALLBACK SOURCES: Try other methods if Liquid data not available

//             // Source 1: Shopify global customer object
//             if (typeof window.ShopifyAnalytics !== 'undefined' &&
//                 window.ShopifyAnalytics.meta &&
//                 window.ShopifyAnalytics.meta.page) {
//                 const meta = window.ShopifyAnalytics.meta;
//                 if (meta.page.customerId) {
//                     customer.id = meta.page.customerId;
//                     customer.isLoggedIn = true;
//                 }
//             }

//             // Source 2: __st global object (Shopify tracking)
//             if (typeof window.__st !== 'undefined' && window.__st.cid) {
//                 customer.id = window.__st.cid;
//                 customer.isLoggedIn = true;
//             }

//             // Source 3: Hidden input fields (commonly used in themes)
//             const customerIdInput = document.getElementById('ms_customer_id');
//             if (customerIdInput && customerIdInput.value && customerIdInput.value !== '0') {
//                 customer.id = customerIdInput.value;
//                 customer.isLoggedIn = true;
//             }

//             // Source 4: Meta tags
//             const customerMeta = document.querySelector('meta[name="customer-id"]');
//             if (customerMeta && customerMeta.content) {
//                 customer.id = customerMeta.content;
//                 customer.isLoggedIn = true;
//             }

//             // Get email from various fallback sources
//             if (!customer.email) {
//                 if (typeof window.customerEmail !== 'undefined' && window.customerEmail) {
//                     customer.email = window.customerEmail;
//                 }
//                 const emailMeta = document.querySelector('meta[name="customer-email"]');
//                 if (emailMeta && emailMeta.content) {
//                     customer.email = emailMeta.content;
//                 }
//             }

//             // Get phone from various fallback sources
//             if (!customer.phone) {
//                 if (typeof window.customerPhone !== 'undefined' && window.customerPhone) {
//                     customer.phone = window.customerPhone;
//                 }
//                 const phoneMeta = document.querySelector('meta[name="customer-phone"]');
//                 if (phoneMeta && phoneMeta.content) {
//                     customer.phone = phoneMeta.content;
//                 }
//             }

//             // Get name from fallback sources
//             if (!customer.name) {
//                 if (typeof window.customerName !== 'undefined' && window.customerName) {
//                     customer.name = window.customerName;
//                 }
//                 const nameMeta = document.querySelector('meta[name="customer-name"]');
//                 if (nameMeta && nameMeta.content) {
//                     customer.name = nameMeta.content;
//                 }
//             }

//         } catch (e) {
//             console.error('[CartSync] Error retrieving customer data:', e);
//         }

//         return customer;
//     }

//     /**
//      * Delays execution for specified milliseconds
//      * @param {number} ms - Milliseconds to delay
//      * @returns {Promise}
//      */
//     function delay(ms) {
//         return new Promise(resolve => setTimeout(resolve, ms));
//     }

//     /**
//      * Calculates exponential backoff delay
//      * @param {number} attempt - Current attempt number (0-indexed)
//      * @returns {number} Delay in milliseconds
//      */
//     function getBackoffDelay(attempt) {
//         const exponentialDelay = CONFIG.RETRY.BASE_DELAY_MS * Math.pow(2, attempt);
//         const jitter = Math.random() * 1000;
//         return Math.min(exponentialDelay + jitter, CONFIG.RETRY.MAX_DELAY_MS);
//     }

//     /**
//      * Creates a debounced version of a function
//      * @param {Function} func - Function to debounce
//      * @param {number} wait - Wait time in milliseconds
//      * @returns {Function} Debounced function
//      */
//     function debounce(func, wait) {
//         let timeout;
//         return function executedFunction(...args) {
//             const later = () => {
//                 clearTimeout(timeout);
//                 func.apply(this, args);
//             };
//             clearTimeout(timeout);
//             timeout = setTimeout(later, wait);
//         };
//     }

//     /**
//      * Extracts device and OS information from the browser
//      * @returns {Object} Device info object with osVersion and deviceDetail
//      */
//     function getDeviceInfo() {
//         const ua = navigator.userAgent || '';
//         let osVersion = 'Unknown';
//         let deviceDetail = 'Unknown';

//         try {
//             // Detect OS Version
//             if (ua.includes('Windows NT 10')) {
//                 osVersion = 'Windows 10/11';
//             } else if (ua.includes('Windows NT 6.3')) {
//                 osVersion = 'Windows 8.1';
//             } else if (ua.includes('Windows NT 6.2')) {
//                 osVersion = 'Windows 8';
//             } else if (ua.includes('Windows NT 6.1')) {
//                 osVersion = 'Windows 7';
//             } else if (ua.includes('Mac OS X')) {
//                 const match = ua.match(/Mac OS X ([\d_]+)/);
//                 osVersion = match ? 'macOS ' + match[1].replace(/_/g, '.') : 'macOS';
//             } else if (ua.includes('Android')) {
//                 const match = ua.match(/Android ([\d.]+)/);
//                 osVersion = match ? 'Android ' + match[1] : 'Android';
//             } else if (ua.includes('iPhone') || ua.includes('iPad')) {
//                 const match = ua.match(/OS ([\d_]+)/);
//                 osVersion = match ? 'iOS ' + match[1].replace(/_/g, '.') : 'iOS';
//             } else if (ua.includes('Linux')) {
//                 osVersion = 'Linux';
//             }

//             // Detect Browser/Device Detail
//             if (ua.includes('Chrome') && !ua.includes('Edg')) {
//                 const match = ua.match(/Chrome\/([\d.]+)/);
//                 deviceDetail = 'Chrome ' + (match ? match[1] : '');
//             } else if (ua.includes('Safari') && !ua.includes('Chrome')) {
//                 const match = ua.match(/Version\/([\d.]+)/);
//                 deviceDetail = 'Safari ' + (match ? match[1] : '');
//             } else if (ua.includes('Firefox')) {
//                 const match = ua.match(/Firefox\/([\d.]+)/);
//                 deviceDetail = 'Firefox ' + (match ? match[1] : '');
//             } else if (ua.includes('Edg')) {
//                 const match = ua.match(/Edg\/([\d.]+)/);
//                 deviceDetail = 'Edge ' + (match ? match[1] : '');
//             }

//             // Add device type
//             if (ua.includes('Mobile')) {
//                 deviceDetail += ' (Mobile)';
//             } else if (ua.includes('Tablet')) {
//                 deviceDetail += ' (Tablet)';
//             } else {
//                 deviceDetail += ' (Desktop)';
//             }
//         } catch (e) {

//         }

//         return {
//             osVersion: osVersion,
//             deviceDetail: deviceDetail.trim()
//         };
//     }

//     /**
//      * Gets the Shopify cart token/ID
//      * @returns {string} Shopify cart ID or empty string
//      */
//     function getShopifyCartId() {
//         try {
//             // Try to get cart token from cookie
//             const cookies = document.cookie.split(';');
//             for (const cookie of cookies) {
//                 const [name, value] = cookie.trim().split('=');
//                 if (name === 'cart' || name === 'cart_token') {
//                     return decodeURIComponent(value);
//                 }
//             }

//             // Try Shopify global object
//             if (typeof Shopify !== 'undefined' && Shopify.cart && Shopify.cart.token) {
//                 return Shopify.cart.token;
//             }

//             // Try fetching from cart.js (cached if already loaded)
//             // This is async so we return empty for now, cart token will be fetched separately
//         } catch (e) {

//         }

//         return '';
//     }

//     /**
//      * Caches SKU for a variant ID in sessionStorage for reliable remove operations
//      * @param {string|number} variantId - Variant ID
//      * @param {string} sku - SKU to cache
//      */
//     function cacheSKU(variantId, sku) {
//         if (!sku || !variantId) return;
//         try {
//             const key = CONFIG.STORAGE_KEYS.SKU_CACHE + String(variantId);
//             sessionStorage.setItem(key, String(sku));
//         } catch (e) {
//             // sessionStorage not available
//         }
//     }

//     /**
//      * Retrieves cached SKU for a variant ID
//      * @param {string|number} variantId - Variant ID
//      * @returns {string} Cached SKU or empty string
//      */
//     function getCachedSKU(variantId) {
//         if (!variantId) return '';
//         try {
//             const key = CONFIG.STORAGE_KEYS.SKU_CACHE + String(variantId);
//             return sessionStorage.getItem(key) || '';
//         } catch (e) {
//             return '';
//         }
//     }

//     /**
//      * Deduplication helper to prevent duplicate API calls
//      * Uses both in-flight tracking (for simultaneous calls) and time-based tracking (for rapid successive calls)
//      * @param {string} action - Action type (add, update, remove)
//      * @param {string|number} variantId - Variant ID
//      * @param {number} quantity - Quantity
//      * @returns {boolean} True if this is a duplicate call (should be skipped)
//      */
//     function isDuplicateCall(action, variantId, quantity) {
//         const key = `${action}_${variantId}_${quantity}`;
//         const now = Date.now();

//         // Initialize tracking objects if not exists
//         if (!window.__ZYDUS_IN_FLIGHT__) {
//             window.__ZYDUS_IN_FLIGHT__ = new Set();
//         }
//         if (!window.__ZYDUS_LAST_CALLS__) {
//             window.__ZYDUS_LAST_CALLS__ = {};
//         }

//         // CRITICAL CHECK 1: Is this exact call currently in-flight?
//         if (window.__ZYDUS_IN_FLIGHT__.has(key)) {

//             return true;
//         }

//         // CRITICAL CHECK 2: Was this exact call made very recently?
//         const lastCall = window.__ZYDUS_LAST_CALLS__[key];
//         if (lastCall && (now - lastCall) < CONFIG.DEDUP_WINDOW_MS) {

//             return true;
//         }

//         // Not a duplicate - record it
//         return false;
//     }

//     /**
//      * Marks a call as in-flight (prevents duplicates during async operations)
//      * @param {string} action 
//      * @param {string|number} variantId 
//      * @param {number} quantity 
//      */
//     function markCallStart(action, variantId, quantity) {
//         const key = `${action}_${variantId}_${quantity}`;
//         if (!window.__ZYDUS_IN_FLIGHT__) {
//             window.__ZYDUS_IN_FLIGHT__ = new Set();
//         }
//         window.__ZYDUS_IN_FLIGHT__.add(key);

//     }

//     /**
//      * Marks a call as completed and records the timestamp
//      * @param {string} action 
//      * @param {string|number} variantId 
//      * @param {number} quantity 
//      */
//     function markCallEnd(action, variantId, quantity) {
//         const key = `${action}_${variantId}_${quantity}`;
//         const now = Date.now();

//         // Remove from in-flight
//         if (window.__ZYDUS_IN_FLIGHT__) {
//             window.__ZYDUS_IN_FLIGHT__.delete(key);
//         }

//         // Record timestamp
//         if (!window.__ZYDUS_LAST_CALLS__) {
//             window.__ZYDUS_LAST_CALLS__ = {};
//         }
//         window.__ZYDUS_LAST_CALLS__[key] = now;



//         // Clean up old timestamp after dedup window
//         setTimeout(() => {
//             if (window.__ZYDUS_LAST_CALLS__) {
//                 delete window.__ZYDUS_LAST_CALLS__[key];
//             }
//         }, CONFIG.DEDUP_WINDOW_MS + 100);
//     }

//     // ============================================================================
//     // API CLIENT
//     // ============================================================================

//     const ApiClient = {
//         /**
//          * Makes an HTTP request with timeout and retry support
//          * @param {string} endpoint - API endpoint
//          * @param {Object} payload - Request payload
//          * @param {number} attempt - Current attempt number
//          * @returns {Promise<Object>} Response data
//          */
//         async request(endpoint, payload, attempt = 0, options = {}) {
//             const url = CONFIG.API_BASE_URL + endpoint;
//             const controller = new AbortController();
//             const timeoutId = setTimeout(() => controller.abort(), CONFIG.REQUEST_TIMEOUT);

//             try {
//                 const fetchOptions = {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Accept': 'application/json'
//                     },
//                     body: JSON.stringify(payload),
//                     signal: controller.signal,
//                     mode: 'cors',
//                     ...options // Merge additional options like keepalive
//                 };

//                 const response = await fetch(url, fetchOptions);

//                 clearTimeout(timeoutId);

//                 if (!response.ok) {
//                     throw new Error(`HTTP error! status: ${response.status}`);
//                 }

//                 const data = await response.json();

//                 // Log detailed response for debugging
//                 if (endpoint === CONFIG.ENDPOINTS.REMOVE_SECURE) {

//                 }

//                 return { success: true, data };

//             } catch (error) {
//                 clearTimeout(timeoutId);

//                 // Check if we should retry
//                 if (attempt < CONFIG.RETRY.MAX_ATTEMPTS - 1) {
//                     const retryDelay = getBackoffDelay(attempt);

//                     await delay(retryDelay);
//                     return this.request(endpoint, payload, attempt + 1, options);
//                 }

//                 console.error('[CartSync] Request failed after all retries:', error);
//                 return { success: false, error: error.message };
//             }
//         },

//         /**
//          * Sends a cart action to the middleware API
//          * @param {string} action - Action type (add, update, remove, wishlist)
//          * @param {string|number} variantId - Shopify variant ID
//          * @param {number} quantity - Item quantity
//          * @param {string} sku - Optional SKU
//          * @returns {Promise<Object>}
//          */
//         async sendCartAction(action, variantId, quantity, sku = '') {
//             // ⚡ FIX #1: Skip API calls for guest users (prevents 422 errors)
//             const customer = getCustomerData();
//             const isGuest = !customer.email && !customer.phone;

//             if (isGuest) {


//                 return { success: true, data: { skipped: true, reason: 'guest_user' } };
//             }

//             // ⚡ CRITICAL: Check for duplicates at the API level (final gate)
//             if (isDuplicateCall(action, variantId, quantity)) {

//                 return { success: true, data: { skipped: true, reason: 'duplicate' } };
//             }

//             // Mark this call as in-flight to block any simultaneous duplicate calls
//             markCallStart(action, variantId, quantity);

//             try {
//                 const deviceInfo = getDeviceInfo();

//                 // Build payload with required fields
//                 const payload = {
//                     // Required fields
//                     email: customer.email || '',
//                     mobile: customer.phone || '',
//                     action: action,

//                     // Product fields - always include
//                     variant_id: String(variantId),
//                     quantity: Number(quantity) || 1,

//                     // Session/Browser tracking
//                     browser_id: getBrowserId(),
//                     session_id: getSessionId(),

//                     // Device/Channel info
//                     channel: 'web',
//                     os_version: deviceInfo.osVersion,
//                     device_detail: deviceInfo.deviceDetail
//                 };

//                 // Only add optional fields if they have values
//                 if (sku && sku.trim()) {
//                     payload.sku = String(sku).trim();
//                 }
//                 if (customer.name && customer.name.trim()) {
//                     payload.customer_name = customer.name.trim();
//                 }
//                 const cartId = getShopifyCartId();
//                 if (cartId && cartId.trim()) {
//                     payload.shopify_cart_id = cartId.trim();
//                 }



//                 // Special handling for remove action - call BOTH endpoints
//                 if (action === 'remove') {


//                     // Try to get SKU from cache if not provided
//                     const finalSku = sku || getCachedSKU(variantId);

//                     // STEP 1: Call /api/cart/action with action: "remove" (for activity logging)

//                     this.request(CONFIG.ENDPOINTS.CART_ACTION, payload, 0, { keepalive: true })
//                         .then(result => {
//                             if (result.success) {

//                             } else {

//                             }
//                         });

//                     // STEP 2: Call /api/cart/remove-secure (for actual secure removal)

//                     const securePayload = {
//                         email: payload.email,
//                         mobile: payload.mobile,
//                         sku: String(finalSku),
//                         shopify_variant_id: String(variantId)
//                     };



//                     const result = await this.request(CONFIG.ENDPOINTS.REMOVE_SECURE, securePayload, 0, { keepalive: true });
//                     return result;
//                 }

//                 // Cache SKU for future remove operations
//                 if (sku && variantId && action !== 'remove') {
//                     cacheSKU(variantId, sku);
//                 }

//                 // Use keepalive: true to ensure request completes even if page unloads/reloads
//                 const result = await this.request(CONFIG.ENDPOINTS.CART_ACTION, payload, 0, { keepalive: true });
//                 return result;

//             } finally {
//                 // Always mark call as complete, regardless of success or error
//                 markCallEnd(action, variantId, quantity);
//             }
//         },

//         /**
//          * Links guest cart to logged-in customer
//          * @returns {Promise<Object>}
//          */
//         async linkGuestCart() {
//             const customer = getCustomerData();

//             if (!customer.isLoggedIn) {

//                 return { success: false, error: 'Customer not logged in' };
//             }

//             const payload = {
//                 browserId: getBrowserId(),
//                 customername: customer.name || '',
//                 customeremail: customer.email || '',
//                 customermobileno: customer.phone || ''
//             };


//             return this.request(CONFIG.ENDPOINTS.UPDATE_BROWSER_ID, payload, 0, { keepalive: true });
//         },

//         /**
//          * Fetches cart items from middleware
//          * @returns {Promise<Object>}
//          */
//         async getCart() {
//             const customer = getCustomerData();

//             const payload = {
//                 email: customer.email || '',
//                 mobile: customer.phone || ''
//             };


//             return this.request(CONFIG.ENDPOINTS.GET_CART, payload, 0, { keepalive: true });
//         },

//         /**
//          * Securely removes an item from cart
//          * @param {string} sku - Product SKU
//          * @param {string|number} variantId - Shopify variant ID
//          * @returns {Promise<Object>}
//          */
//         async removeSecure(sku, variantId) {
//             const customer = getCustomerData();

//             const payload = {
//                 email: customer.email || '',
//                 mobile: customer.phone || '',
//                 sku: String(sku),
//                 shopify_variant_id: String(variantId)
//             };


//             return this.request(CONFIG.ENDPOINTS.REMOVE_SECURE, payload, 0, { keepalive: true });
//         }
//     };

//     // ============================================================================
//     // CART EVENT INTERCEPTOR
//     // ============================================================================

//     const CartInterceptor = {
//         originalFetch: null,
//         originalXHROpen: null,
//         originalXHRSend: null,

//         /**
//          * Initializes the cart event interceptor
//          */
//         init() {
//             this.interceptFetch();
//             this.interceptXHR();
//             this.interceptFormSubmissions();
//             this.observeCartChanges();

//         },

//         /**
//          * Intercepts fetch API calls to Shopify cart endpoints
//          */
//         interceptFetch() {
//             this.originalFetch = window.fetch;
//             const self = this;

//             window.fetch = async function (input, init) {
//                 const url = typeof input === 'string' ? input : input.url;

//                 // Call original fetch
//                 const response = await self.originalFetch.apply(this, arguments);

//                 // Check if this is a cart-related request
//                 if (self.isCartEndpoint(url)) {
//                     // Clone response for processing
//                     const clonedResponse = response.clone();

//                     try {
//                         const data = await clonedResponse.json();
//                         self.processCartResponse(url, init, data);
//                     } catch (e) {
//                         // Response might not be JSON
//                     }
//                 }

//                 return response;
//             };
//         },

//         /**
//          * Intercepts XMLHttpRequest calls to Shopify cart endpoints
//          */
//         interceptXHR() {
//             const self = this;
//             this.originalXHROpen = XMLHttpRequest.prototype.open;
//             this.originalXHRSend = XMLHttpRequest.prototype.send;

//             XMLHttpRequest.prototype.open = function (method, url) {
//                 this._cartSyncUrl = url;
//                 this._cartSyncMethod = method;
//                 return self.originalXHROpen.apply(this, arguments);
//             };

//             XMLHttpRequest.prototype.send = function (body) {
//                 const xhr = this;
//                 const url = this._cartSyncUrl;

//                 if (self.isCartEndpoint(url)) {
//                     this._cartSyncBody = body;

//                     this.addEventListener('load', function () {
//                         try {
//                             const data = JSON.parse(xhr.responseText);
//                             self.processCartResponse(url, { method: xhr._cartSyncMethod, body }, data);
//                         } catch (e) {
//                             // Response might not be JSON
//                         }
//                     });
//                 }

//                 return self.originalXHRSend.apply(this, arguments);
//             };
//         },

//         /**
//          * Intercepts cart form submissions
//          */
//         interceptFormSubmissions() {
//             const self = this;

//             document.addEventListener('submit', function (event) {
//                 const form = event.target;

//                 if (form.action && (
//                     form.action.includes('/cart/add') ||
//                     form.action.includes('/cart')
//                 )) {
//                     // ⚡ FIX for Issue #2: Skip logging if we're in sync mode
//                     if (window.__ZYDUS_SYNCING__) {

//                         return;
//                     }

//                     // Extract form data
//                     const formData = new FormData(form);
//                     const variantId = formData.get('id') || formData.get('variant_id');
//                     const quantity = formData.get('quantity') || 1;

//                     // Extract SKU from form
//                     let sku = formData.get('sku') || '';
//                     if (!sku) {
//                         // Try hidden input with class product-sku
//                         const skuInput = form.querySelector('.product-sku, input[name="sku"]');
//                         if (skuInput) {
//                             sku = skuInput.value || '';
//                         }
//                     }
//                     if (!sku) {
//                         // Try data-sku attribute on quantity input
//                         const qtyInput = form.querySelector('.quantity__input, input[name="quantity"]');
//                         if (qtyInput && qtyInput.dataset.sku) {
//                             sku = qtyInput.dataset.sku;
//                         }
//                     }

//                     if (variantId) {


//                         // Cache SKU for future use
//                         if (sku) cacheSKU(variantId, sku);

//                         // Send API action (deduplication happens inside sendCartAction)
//                         ApiClient.sendCartAction('add', variantId, quantity, sku).then(result => {
//                             if (result.success) {
//                                 if (result.data && result.data.skipped) {

//                                 } else {

//                                 }
//                             } else {
//                                 console.error('[CartSync] ❌ API FAILED - Add to Cart (Form):', result.error);
//                             }
//                         });
//                     }
//                 }
//             }, true);
//         },

//         /**
//          * Observes DOM changes for cart updates
//          */
//         observeCartChanges() {
//             const self = this;

//             // Debounced handler for cart drawer changes
//             const debouncedCartCheck = debounce(() => {
//                 self.syncCurrentCart();
//             }, CONFIG.DEBOUNCE_DELAY);

//             // Observe cart drawer and cart page changes
//             const observer = new MutationObserver((mutations) => {
//                 for (const mutation of mutations) {
//                     if (mutation.type === 'childList') {
//                         const target = mutation.target;
//                         if (target.classList && (
//                             target.classList.contains('cart-drawer') ||
//                             target.classList.contains('cart-items') ||
//                             target.id === 'cart'
//                         )) {
//                             debouncedCartCheck();
//                         }
//                     }
//                 }
//             });

//             observer.observe(document.body, {
//                 childList: true,
//                 subtree: true
//             });
//         },

//         /**
//          * Checks if URL is a Shopify cart endpoint
//          * ⚡ FIX #3: Only match Shopify endpoints, not middleware API
//          * @param {string} url - Request URL
//          * @returns {boolean}
//          */
//         isCartEndpoint(url) {
//             if (!url) return false;

//             // Exclude middleware API endpoints (start with /api/ or full API URL)
//             if (url.includes('/api/cart/') || url.startsWith(CONFIG.API_BASE_URL)) {
//                 return false;
//             }

//             // Only match Shopify cart endpoints (ending with .js)
//             return (url.includes('/cart/add.js') || url.includes('/cart/add?')) ||
//                 (url.includes('/cart/update.js') || url.includes('/cart/update?')) ||
//                 (url.includes('/cart/change.js') || url.includes('/cart/change?')) ||
//                 (url.includes('/cart/clear.js') || url.includes('/cart/clear?'));
//         },

//         /**
//          * Processes cart API response and syncs with middleware
//          * @param {string} url - Request URL
//          * @param {Object} init - Request init options
//          * @param {Object} data - Response data
//          */
//         processCartResponse(url, init, data) {
//             if (!data) return;

//             // ⚡ FIX for Issue #2: Skip logging if we're in sync mode
//             if (window.__ZYDUS_SYNCING__) {

//                 return;
//             }

//             if (url.includes('/cart/add')) {
//                 this.handleCartAddResponse(data);
//             } else if (url.includes('/cart/change') || url.includes('/cart/update')) {
//                 this.handleCartUpdateResponse(init, data);
//             } else if (url.includes('/cart/clear')) {
//                 this.handleCartClear();
//             }
//         },

//         /**
//          * Handles add to cart response
//          * @param {Object} data - Response data from Shopify
//          */
//         handleCartAddResponse(data) {
//             // data could be a single item or cart object
//             const item = data.items ? data.items[0] : data;

//             if (item && item.variant_id) {
//                 const sku = item.sku || '';
//                 const quantity = item.quantity || 1;



//                 // Cache SKU for future remove operations
//                 if (sku) cacheSKU(item.variant_id, sku);

//                 // Send add action to middleware API (deduplication happens inside sendCartAction)
//                 ApiClient.sendCartAction('add', item.variant_id, quantity, sku).then(result => {
//                     if (result.success) {
//                         if (result.data && result.data.skipped) {

//                         } else {


//                         }
//                     } else {
//                         console.error('[CartSync] ❌ API FAILED - Add to Cart:', result.error);
//                     }
//                 });
//             }
//         },

//         /**
//          * Handles cart add event
//          * @param {string|number} variantId - Variant ID
//          * @param {number} quantity - Quantity
//          * @param {string} sku - SKU
//          */
//         handleCartAdd(variantId, quantity, sku = '') {

//             ApiClient.sendCartAction('add', variantId, quantity, sku).then(result => {
//                 if (result.success) {


//                 } else {
//                     console.error('[CartSync] ❌ API FAILED - Add to Cart:', result.error);
//                 }
//             });
//         },

//         /**
//          * Handles cart update/change response
//          * @param {Object} init - Request init options
//          * @param {Object} data - Response data from Shopify (cart object after update)
//          */
//         handleCartUpdateResponse(init, data) {
//             try {
//                 // Step 1: Parse the request body to understand what was requested
//                 const requestBody = this.parseRequestBody(init);

//                 // Only log if request body has content
//                 if (Object.keys(requestBody).length > 0) {

//                 }

//                 // Step 2: Extract variant ID and quantity from request
//                 const { variantId, quantity } = this.extractCartUpdateInfo(requestBody, data);

//                 // Skip if no variant ID (invalid request)
//                 if (!variantId) {

//                     return;
//                 }

//                 // Step 3: Determine if this is a remove action
//                 const isRemove = this.isRemoveAction(quantity, variantId, data);

//                 // Step 4: Get SKU (from response or cache)
//                 const sku = this.getSKUForVariant(variantId, data, isRemove);

//                 // Step 5: Send appropriate action to API (with deduplication)
//                 this.sendCartUpdateToAPI(isRemove ? 'remove' : 'update', variantId, quantity, sku);

//             } catch (e) {
//                 console.error('[CartSync] Error processing cart update:', e);
//             }
//         },

//         /**
//          * Parses request body from various formats (JSON, URLEncoded, FormData)
//          * @param {Object} init - Request init options
//          * @returns {Object} Parsed request body
//          */
//         parseRequestBody(init) {
//             let requestBody = {};

//             if (!init || !init.body) return requestBody;

//             if (typeof init.body === 'string') {
//                 const bodyStr = init.body.trim();
//                 if (bodyStr.startsWith('{')) {
//                     // JSON format: {"quantity": 5, "id": "123"}
//                     requestBody = JSON.parse(bodyStr);
//                 } else {
//                     // URL-encoded format: quantity=5&id=123&line=1
//                     const params = new URLSearchParams(bodyStr);
//                     for (const [key, value] of params.entries()) {
//                         requestBody[key] = value;
//                     }
//                 }
//             } else if (init.body instanceof FormData) {
//                 for (let [key, value] of init.body.entries()) {
//                     requestBody[key] = value;
//                 }
//             }

//             return requestBody;
//         },

//         /**
//          * Extracts variant ID and quantity from request body
//          * @param {Object} requestBody - Parsed request body
//          * @param {Object} data - Shopify cart response
//          * @returns {Object} { variantId, quantity }
//          */
//         extractCartUpdateInfo(requestBody, data) {
//             let quantity = requestBody.quantity !== undefined ? Number(requestBody.quantity) : null;
//             let rawId = null;
//             let variantId = null;

//             // Validate: Must have either 'id', 'line', or 'updates'
//             if (!requestBody.id && !requestBody.line && !requestBody.updates) {


//                 return { variantId: null, quantity: null };
//             }

//             // Handle 'updates' payload (e.g. { updates: { "variant_id": qty } })
//             if (requestBody.updates && typeof requestBody.updates === 'object') {
//                 const keys = Object.keys(requestBody.updates);
//                 if (keys.length > 0) {
//                     rawId = keys[0];
//                     quantity = Number(requestBody.updates[rawId]);

//                 }
//             }

//             // Priority 1: Use 'line' parameter if available (most reliable for themes)
//             // This gets variant from cart response by line number
//             const lineNum = Number(requestBody.line);
//             if (lineNum && lineNum > 0 && data && data.items && data.items[lineNum - 1]) {
//                 const lineItem = data.items[lineNum - 1];
//                 variantId = Number(lineItem.variant_id);

//                 return { variantId, quantity };
//             }

//             // Priority 2: Use 'id' parameter if 'line' not available
//             if (!rawId && requestBody.id) {
//                 rawId = requestBody.id;
//             }

//             // Parse variant ID from line item key or id
//             // Shopify format: "variant_id:hash" or just "variant_id"
//             if (rawId) {
//                 const idStr = String(rawId);
//                 if (idStr.includes(':')) {
//                     // Line item key format: "12345:abc123"
//                     variantId = Number(idStr.split(':')[0]);

//                 } else {
//                     // Just variant ID
//                     variantId = Number(idStr);

//                 }
//             }

//             return { variantId, quantity };
//         },

//         /**
//          * Determines if this is a remove action
//          * @param {number} quantity - Requested quantity
//          * @param {number} variantId - Variant ID
//          * @param {Object} data - Shopify cart response
//          * @returns {boolean}
//          */
//         isRemoveAction(quantity, variantId, data) {
//             // Explicit quantity = 0 means remove
//             if (quantity === 0) {

//                 return true;
//             }

//             // If item is not in cart response, it was removed
//             if (data && data.items && variantId) {
//                 const itemInCart = data.items.find(item =>
//                     String(item.variant_id) === String(variantId)
//                 );
//                 if (!itemInCart) {

//                     return true;
//                 }
//             }

//             return false;
//         },

//         /**
//          * Gets SKU for a variant (from cart response, DOM, or cache)
//          * @param {number} variantId - Variant ID
//          * @param {Object} data - Shopify cart response
//          * @param {boolean} isRemove - Whether this is a remove action
//          * @returns {string} SKU
//          */
//         getSKUForVariant(variantId, data, isRemove) {
//             let sku = '';

//             // Try to get SKU from cart response
//             if (data && data.items) {
//                 const item = data.items.find(i => String(i.variant_id) === String(variantId));
//                 if (item) {
//                     sku = item.sku || '';

//                     // Cache it for future use
//                     if (sku) cacheSKU(variantId, sku);
//                 }
//             }

//             // ⚡ FIX: For remove actions, try to get SKU from DOM if not found
//             if (isRemove && !sku) {
//                 // Try to find SKU from cart item in DOM (data-sku attribute)
//                 try {
//                     const cartItemElement = document.querySelector(
//                         `.select-qty[data-varid="${variantId}"][data-sku], ` +
//                         `[data-variant-id="${variantId}"][data-sku], ` +
//                         `[data-product-id="${variantId}"][data-sku]`
//                     );
//                     if (cartItemElement && cartItemElement.dataset.sku) {
//                         sku = cartItemElement.dataset.sku;

//                         // Cache it for future use
//                         if (sku) cacheSKU(variantId, sku);
//                     }
//                 } catch (e) {

//                 }
//             }

//             // For remove actions, try cached SKU as last resort
//             if (isRemove && !sku) {
//                 sku = getCachedSKU(variantId);

//             }

//             return sku;
//         },

//         /**
//          * Sends cart update to API (with deduplication)
//          * @param {string} action - 'update' or 'remove'
//          * @param {number} variantId - Variant ID
//          * @param {number} quantity - Quantity
//          * @param {string} sku - SKU
//          */
//         sendCartUpdateToAPI(action, variantId, quantity, sku) {
//             // Check for duplicate calls
//             if (isDuplicateCall(action, variantId, quantity)) {
//                 return; // Skip duplicate
//             }



//             ApiClient.sendCartAction(action, variantId, quantity || 0, sku).then(result => {
//                 if (result.success) {


//                 } else {
//                     console.error(`[CartSync] ❌ API FAILED - ${action}:`, result.error);
//                 }
//             });
//         },

//         /**
//          * Handles cart clear event
//          */
//         handleCartClear() {
//             // Fetch current cart from Shopify to get all items being removed
//             fetch('/cart.js')
//                 .then(r => r.json())
//                 .then(cart => {
//                     if (cart.items && cart.items.length > 0) {
//                         cart.items.forEach(item => {
//                             ApiClient.sendCartAction('remove', item.variant_id, 0);
//                         });
//                     }
//                 })
//                 .catch(e => console.error('[CartSync] Error fetching cart for clear:', e));
//         },

//         /**
//          * Syncs current Shopify cart state with middleware
//          */
//         async syncCurrentCart() {
//             try {
//                 const response = await fetch('/cart.js');
//                 const cart = await response.json();



//                 // This could be extended to do a full cart reconciliation
//             } catch (e) {
//                 console.error('[CartSync] Error syncing current cart:', e);
//             }
//         }
//     };

//     // ============================================================================
//     // WISHLIST HANDLER
//     // ============================================================================

//     const WishlistHandler = {
//         /**
//          * Initializes wishlist event handlers
//          */
//         init() {
//             this.bindWishlistButtons();
//             this.observeWishlistChanges();

//         },

//         /**
//          * Binds click handlers to wishlist buttons
//          */
//         bindWishlistButtons() {
//             const self = this;

//             document.addEventListener('click', function (event) {
//                 const target = event.target.closest('[data-wishlist-add], [data-move-to-wishlist], .add-to-wishlist, .move-to-wishlist');

//                 if (target) {
//                     const variantId = target.dataset.variantId ||
//                         target.dataset.productVariantId ||
//                         target.closest('[data-variant-id]')?.dataset.variantId;

//                     if (variantId) {
//                         self.addToWishlist(variantId);
//                     }
//                 }
//             }, true);
//         },

//         /**
//          * Observes DOM for dynamically added wishlist buttons
//          */
//         observeWishlistChanges() {
//             const self = this;

//             const observer = new MutationObserver((mutations) => {
//                 for (const mutation of mutations) {
//                     if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
//                         mutation.addedNodes.forEach(node => {
//                             if (node.nodeType === 1) { // Element node
//                                 const wishlistBtns = node.querySelectorAll?.('[data-wishlist-add], [data-move-to-wishlist]');
//                                 if (wishlistBtns && wishlistBtns.length > 0) {
//                                     // New wishlist buttons found, they'll be handled by event delegation
//                                 }
//                             }
//                         });
//                     }
//                 }
//             });

//             observer.observe(document.body, {
//                 childList: true,
//                 subtree: true
//             });
//         },

//         /**
//          * Adds item to wishlist via middleware API
//          * @param {string|number} variantId - Shopify variant ID
//          */
//         addToWishlist(variantId) {

//             ApiClient.sendCartAction('wishlist', variantId, 1);
//         },

//         /**
//          * Moves item from cart to wishlist
//          * @param {string|number} variantId - Shopify variant ID
//          */
//         moveFromCartToWishlist(variantId) {
//             // First add to wishlist
//             this.addToWishlist(variantId);

//             // Then remove from cart (Shopify side)
//             fetch('/cart/change.js', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ id: variantId, quantity: 0 })
//             }).catch(e => console.error('[CartSync] Error removing from cart:', e));
//         }
//     };

//     // ============================================================================
//     // GUEST CART LINKER
//     // ============================================================================

//     const GuestCartLinker = {
//         /**
//          * Initializes guest cart linking functionality
//          */
//         init() {
//             this.checkLoginStatus();
//             this.observeLoginChanges();

//         },

//         /**
//          * Checks if user just logged in and links guest cart + syncs from backend
//          */
//         async checkLoginStatus() {
//             const customer = getCustomerData();

//             if (customer.isLoggedIn) {
//                 try {
//                     const lastCustomerId = localStorage.getItem(CONFIG.STORAGE_KEYS.LAST_CUSTOMER_ID);
//                     const wasLinked = localStorage.getItem(CONFIG.STORAGE_KEYS.GUEST_LINKED);

//                     // If this is a new login or different customer
//                     if (!wasLinked || lastCustomerId !== customer.id) {
//                         // First, link any guest cart data to this customer
//                         await this.linkGuestCart();

//                         localStorage.setItem(CONFIG.STORAGE_KEYS.LAST_CUSTOMER_ID, customer.id);
//                         localStorage.setItem(CONFIG.STORAGE_KEYS.GUEST_LINKED, 'true');
//                     }

//                     // ⚡ CRITICAL FIX: Always sync on page load for cross-device consistency
//                     // This ensures updates/removes from other devices are reflected
//                     await this.syncCartFromBackend();

//                 } catch (e) {
//                     // localStorage not available
//                     await this.linkGuestCart();
//                     await this.syncCartFromBackend();
//                 }
//             } else {
//                 // User is logged out
//                 // Clear linking flags and cache
//                 try {
//                     const wasLoggedIn = localStorage.getItem(CONFIG.STORAGE_KEYS.LAST_CUSTOMER_ID);

//                     // If there was a previous login, clear the cart
//                     if (wasLoggedIn) {

//                         fetch('/cart/clear.js', {
//                             method: 'POST',
//                             headers: {
//                                 'Content-Type': 'application/json',
//                                 'Accept': 'application/json'
//                             }
//                         })
//                             .then(response => {
//                                 if (response.ok) {

//                                 }
//                             })
//                             .catch(e => console.error('[CartSync] Error clearing cart:', e));
//                     }

//                     localStorage.removeItem(CONFIG.STORAGE_KEYS.GUEST_LINKED);
//                     localStorage.removeItem(CONFIG.STORAGE_KEYS.LAST_CUSTOMER_ID);

//                     // Clear all cart sync flags from sessionStorage
//                     const keys = Object.keys(sessionStorage);
//                     keys.forEach(key => {
//                         if (key.startsWith(CONFIG.STORAGE_KEYS.CART_SYNCED)) {
//                             sessionStorage.removeItem(key);
//                         }
//                     });

//                     // Clear SKU cache
//                     Object.keys(sessionStorage).forEach(key => {
//                         if (key.startsWith(CONFIG.STORAGE_KEYS.SKU_CACHE)) {
//                             sessionStorage.removeItem(key);
//                         }
//                     });
//                 } catch (e) {
//                     // localStorage/sessionStorage not available
//                 }
//             }
//         },

//         /**
//          * Observes for login state changes (e.g., after AJAX login)
//          */
//         observeLoginChanges() {
//             const self = this;
//             let previousLoginState = getCustomerData().isLoggedIn;

//             // Check periodically for login state changes
//             setInterval(async () => {
//                 const currentLoginState = getCustomerData().isLoggedIn;

//                 if (currentLoginState && !previousLoginState) {
//                     // User just logged in
//                     await self.linkGuestCart();
//                     await self.syncCartFromBackend();

//                     try {
//                         const customer = getCustomerData();
//                         localStorage.setItem(CONFIG.STORAGE_KEYS.LAST_CUSTOMER_ID, customer.id);
//                         localStorage.setItem(CONFIG.STORAGE_KEYS.GUEST_LINKED, 'true');
//                     } catch (e) {
//                         // localStorage not available
//                     }
//                 } else if (!currentLoginState && previousLoginState) {
//                     // User logged out


//                     // Record logout timestamp to prevent immediate sync on re-login
//                     try {
//                         localStorage.setItem(CONFIG.STORAGE_KEYS.LOGOUT_TIMESTAMP, Date.now().toString());
//                     } catch (e) {
//                         // localStorage not available
//                     }

//                     // Clear Shopify cart since guest checkout is disabled
//                     // Items are already saved in backend, will sync back on re-login
//                     fetch('/cart/clear.js', {
//                         method: 'POST',
//                         headers: {
//                             'Content-Type': 'application/json',
//                             'Accept': 'application/json'
//                         }
//                     })
//                         .then(response => {
//                             if (response.ok) {

//                                 // Dispatch event for cart drawer to update
//                                 document.dispatchEvent(new CustomEvent('cart:updated'));
//                             } else {

//                             }
//                         })
//                         .catch(e => {
//                             console.error('[CartSync] Error clearing cart on logout:', e);
//                         });

//                     // Clear flags and cache
//                     try {
//                         localStorage.removeItem(CONFIG.STORAGE_KEYS.GUEST_LINKED);
//                         localStorage.removeItem(CONFIG.STORAGE_KEYS.LAST_CUSTOMER_ID);

//                         // Clear all cart sync flags from sessionStorage
//                         const keys = Object.keys(sessionStorage);
//                         keys.forEach(key => {
//                             if (key.startsWith(CONFIG.STORAGE_KEYS.CART_SYNCED)) {
//                                 sessionStorage.removeItem(key);
//                             }
//                         });

//                         // Clear SKU cache as well
//                         Object.keys(sessionStorage).forEach(key => {
//                             if (key.startsWith(CONFIG.STORAGE_KEYS.SKU_CACHE)) {
//                                 sessionStorage.removeItem(key);
//                             }
//                         });
//                     } catch (e) {
//                         // localStorage/sessionStorage not available
//                     }
//                 }

//                 previousLoginState = currentLoginState;
//             }, 2000);
//         },

//         /**
//          * Links guest cart to logged-in customer
//          */
//         async linkGuestCart() {
//             const result = await ApiClient.linkGuestCart();

//             if (result.success) {

//             } else {

//             }
//         },

//         /**
//          * Shows the natve loading spinner on specific cart items during background sync.
//          * Creates a non-blocking UI experience instead of a full-page loader.
//          * @param {Array<string>} variantIds - Array of variant IDs being updated or removed
//          */
//         showItemLoaders(variantIds) {
//             if (!variantIds || variantIds.length === 0 || !window.location.pathname.includes('/cart')) return;

//             variantIds.forEach(id => {
//                 // Find the quantity input for this variant to identify its row
//                 const input = document.getElementById(`updates_${id}`);
//                 if (input) {
//                     // Find the closest cart-item row
//                     const row = input.closest('.cart-item-main, .cart-item');
//                     if (row) {
//                         // Find and show the loader inside this exact row
//                         const loader = row.querySelector('.cartLoader');
//                         if (loader) {
//                             loader.classList.remove('hidden');
//                         }
//                     }
//                 }
//             });
//         },

//         /**
//          * Safely triggers a native UI refresh using Shopify's existing cart-items component.
//          * Eliminates double reloads while keeping JS events (like qty buttons) fully working.
//          */
//         safelyRefreshCartUI() {
//             if (!window.location.pathname.includes('/cart')) return;



//             // Notify theme components (header cart count, etc.)
//             document.dispatchEvent(new CustomEvent('cart:updated'));

//             const cartItemsEl = document.querySelector('cart-items');
//             if (cartItemsEl && typeof cartItemsEl.onCartUpdate === 'function') {
//                 // Listen for the native refresh completion before hiding loader
//                 const hideLoaderOnce = () => {
//                     const loader = document.getElementById('cart-sync-loader');
//                     if (loader) loader.style.display = 'none';
//                     document.removeEventListener('cart:updated', hideLoaderOnce);
//                 };
//                 document.addEventListener('cart:updated', hideLoaderOnce);

//                 // Use Shopify's native component to fetch and swap HTML cleanly
//                 // This usually takes 1-2 seconds, so the loader stays up until cart:updated fires
//                 cartItemsEl.onCartUpdate();



//             } else {

//                 window.location.reload();
//             }
//         },

//         /**
//          * Syncs cart data from backend to Shopify cart (cross-device sync)
//          * Called when user logs in on a new device
//          */
//         async syncCartFromBackend() {
//             // ⚡ FIX for Issue #2: Set global flag to prevent duplicate logging during sync
//             window.__ZYDUS_SYNCING__ = true;
//             const syncStartTime = Date.now();




//             try {
//                 const customer = getCustomerData();
//                 const syncKey = `${CONFIG.STORAGE_KEYS.CART_SYNCED}_${customer.id}`;
//                 const isCartPage = window.location.pathname.includes('/cart');

//                 // Check if user just logged out recently (within 5 seconds)
//                 // If so, skip sync to prevent cart from repopulating after manual clear
//                 try {
//                     const logoutTimestamp = localStorage.getItem(CONFIG.STORAGE_KEYS.LOGOUT_TIMESTAMP);
//                     if (logoutTimestamp) {
//                         const timeSinceLogout = Date.now() - Number(logoutTimestamp);
//                         if (timeSinceLogout < CONFIG.LOGOUT_SYNC_DELAY_MS) {

//                             // Clear the timestamp so next login will sync
//                             localStorage.removeItem(CONFIG.STORAGE_KEYS.LOGOUT_TIMESTAMP);
//                             return;
//                         }
//                         // Clear old timestamp
//                         localStorage.removeItem(CONFIG.STORAGE_KEYS.LOGOUT_TIMESTAMP);
//                     }
//                 } catch (e) {
//                     // localStorage not available
//                 }

//                 // ⚡ SAFEGUARD: Only skip sync if user is ACTIVELY performing an action
//                 // This prevents sync from interfering with in-progress operations
//                 // But ALLOWS sync for cross-device changes (other browser's actions)
//                 if (window.__ZYDUS_IN_FLIGHT__ && window.__ZYDUS_IN_FLIGHT__.size > 0) {

//                     return;
//                 }

//                 // ⚡ FIX: Relaxed safeguard for cross-device sync
//                 // Allow sync on page load even if there were recent actions
//                 // Only block if action happened in last 100ms (very recent)
//                 if (window.__ZYDUS_LAST_CALLS__) {
//                     const now = Date.now();
//                     const veryRecentCalls = Object.values(window.__ZYDUS_LAST_CALLS__).filter(timestamp => {
//                         return (now - timestamp) < 100; // Reduced to 100ms for faster cross-device sync
//                     });
//                     if (veryRecentCalls.length > 0) {

//                         return;
//                     }
//                 }

//                 let alreadySynced = false;
//                 try {
//                     alreadySynced = sessionStorage.getItem(syncKey) === 'true';
//                 } catch (e) {
//                     // sessionStorage not available
//                 }

//                 // Sync should run on every login/check to ensure cross-device consistency
//                 // We trust the duplicate check logic to prevent double-adding items
//                 /*
//                 if (alreadySynced) {

//                     return;
//                 }
//                 */





//                 // Get cart data from middleware
//                 const result = await ApiClient.getCart();

//                 if (!result.success) {

//                     return;
//                 }

//                 const backendItems = result.data?.items || [];


//                 // Get current Shopify cart BEFORE checking if backend is empty
//                 const shopifyCartResponse = await fetch('/cart.js');
//                 const shopifyCart = await shopifyCartResponse.json();

//                 if (backendItems.length === 0) {


//                     // ⚡ FIX #2: Preserve guest cart on login (push to backend instead of clearing)
//                     if (shopifyCart.items && shopifyCart.items.length > 0) {
//                         // Check if this might be a guest cart (first-time sync with items in Shopify)
//                         const isFirstSync = !alreadySynced;

//                         if (isFirstSync) {
//                             // Guest cart scenario: User added items as guest, then logged in
//                             // Push Shopify items TO backend to preserve them



//                             let pushedCount = 0;
//                             for (const item of shopifyCart.items) {
//                                 const variantId = String(item.variant_id);
//                                 const quantity = Number(item.quantity) || 1;
//                                 const sku = item.sku || '';

//                                 try {

//                                     const pushResult = await ApiClient.sendCartAction('add', variantId, quantity, sku);

//                                     if (pushResult.success) {
//                                         pushedCount++;

//                                     } else {

//                                     }
//                                 } catch (error) {
//                                     console.error(`[CartSync] Error pushing variant ${variantId}:`, error);
//                                 }

//                                 // Small delay to avoid rate limiting
//                                 await delay(200);
//                             }



//                         } else {
//                             // Returning user scenario: Backend deliberately empty (cart cleared on another device)
//                             // Clear Shopify to match backend


//                             try {
//                                 await fetch('/cart/clear.js', {
//                                     method: 'POST',
//                                     headers: {
//                                         'Content-Type': 'application/json',
//                                         'Accept': 'application/json'
//                                     }
//                                 });


//                                 // ⚡ FIX: Reload page to show empty cart (timestamp-based, same as add/update logic)
//                                 const reloadTimestampKey = `${CONFIG.STORAGE_KEYS.CART_SYNCED}_last_reload_time`;
//                                 let lastReloadTime = 0;
//                                 try {
//                                     const stored = sessionStorage.getItem(reloadTimestampKey);
//                                     lastReloadTime = stored ? parseInt(stored, 10) : 0;
//                                 } catch (e) { }

//                                 const now = Date.now();
//                                 const timeSinceLastReload = now - lastReloadTime;
//                                 const MIN_RELOAD_INTERVAL = 3000; // 3 seconds minimum between reloads

//                                 if (timeSinceLastReload > MIN_RELOAD_INTERVAL) {
//                                     // Enough time has passed, safe to reload
//                                     try {
//                                         sessionStorage.setItem(reloadTimestampKey, now.toString());
//                                     } catch (e) { }


//                                     this.safelyRefreshCartUI();
//                                     return; // Don't continue after refresh
//                                 } else {
//                                     // Too soon since last reload, just dispatch event

//                                     document.dispatchEvent(new CustomEvent('cart:updated'));
//                                 }
//                             } catch (e) {
//                                 console.error('[CartSync] Error clearing Shopify cart:', e);
//                             }
//                         }
//                     } else {

//                     }

//                     // Mark as synced even if empty
//                     try {
//                         sessionStorage.setItem(syncKey, 'true');
//                     } catch (e) { }
//                     return;
//                 }





//                 // Create a map of existing items by variant_id for easy lookup
//                 const existingItemsMap = new Map();
//                 shopifyCart.items.forEach(item => {
//                     existingItemsMap.set(String(item.variant_id), {
//                         key: item.key,
//                         quantity: item.quantity
//                     });
//                 });

//                 let syncedCount = 0;
//                 let updatedCount = 0;
//                 let skippedCount = 0;

//                 // ⚡ FAST SYNC: Collect all operations first, then execute in bulk
//                 const itemsToAdd = [];      // New items to add (bulk via items[])
//                 const itemsToUpdate = {};   // Qty changes (bulk via updates{})

//                 // Process each backend item — decide add vs update
//                 for (const item of backendItems) {
//                     const variantId = String(item.variant_id || item.shopify_variant_id);
//                     const backendQuantity = Number(item.quantity) || 1;
//                     const existingItem = existingItemsMap.get(variantId);

//                     if (existingItem) {
//                         if (existingItem.quantity !== backendQuantity) {

//                             // /cart/update.js uses variant id as key for updates
//                             itemsToUpdate[variantId] = backendQuantity;
//                             updatedCount++;
//                         } else {

//                             skippedCount++;
//                         }
//                     } else {

//                         itemsToAdd.push({ id: parseInt(variantId), quantity: backendQuantity });
//                     }
//                 }

//                 // ── STEP 1: Bulk ADD all missing items in one request ──────────────────
//                 if (itemsToAdd.length > 0) {

//                     try {
//                         const addResponse = await fetch('/cart/add.js', {
//                             method: 'POST',
//                             headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//                             body: JSON.stringify({ items: itemsToAdd })
//                         });
//                         if (addResponse.ok) {
//                             syncedCount = itemsToAdd.length;

//                         } else {
//                             // Bulk failed — fall back to one-by-one so we can inspect each error
//                             // ✅ Add 300ms delay between requests to avoid Cloudflare rate limiting
//                             for (const item of itemsToAdd) {
//                                 try {
//                                     const r = await fetch('/cart/add.js', {
//                                         method: 'POST',
//                                         headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//                                         body: JSON.stringify(item)
//                                     });
//                                     if (r.ok) syncedCount++;
//                                     else skippedCount++;
//                                     await delay(300);
//                                 } catch (e) { skippedCount++; }
//                             }
//                         }
//                     } catch (error) {
//                         console.error(`[CartSync] Error in bulk add:`, error);
//                         skippedCount += itemsToAdd.length;
//                     }
//                 }

//                 // ── STEP 2: Bulk UPDATE quantities in one request ──────────────────────
//                 if (Object.keys(itemsToUpdate).length > 0) {

//                     try {
//                         const updateResponse = await fetch('/cart/update.js', {
//                             method: 'POST',
//                             headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//                             body: JSON.stringify({ updates: itemsToUpdate })
//                         });
//                         if (updateResponse.ok) {

//                         } else {
//                             const errData = await updateResponse.json();

//                             updatedCount = 0;
//                             skippedCount += Object.keys(itemsToUpdate).length;
//                         }
//                     } catch (error) {
//                         console.error(`[CartSync] Error in bulk update:`, error);
//                         skippedCount += Object.keys(itemsToUpdate).length;
//                     }
//                 }

//                 // ── STEP 3: Parallel REMOVE items not in backend ───────────────────────
//                 let removedCount = 0;
//                 const removedVariantIds = [];
//                 const backendVariantIds = new Set(backendItems.map(item => String(item.variant_id || item.shopify_variant_id)));





//                 const removePromises = [];
//                 for (const [variantId, itemData] of existingItemsMap.entries()) {
//                     if (!backendVariantIds.has(variantId)) {

//                         removedVariantIds.push(variantId);
//                         removePromises.push(
//                             fetch('/cart/change.js', {
//                                 method: 'POST',
//                                 headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//                                 body: JSON.stringify({ id: itemData.key, quantity: 0 })
//                             }).then(r => {
//                                 if (r.ok) { removedCount++;  }
//                                 else {  }
//                             }).catch(e => console.error(`[CartSync] Error removing variant ${variantId}:`, e))
//                         );
//                     } else {

//                     }
//                 }

//                 if (removePromises.length > 0) {

//                     await Promise.all(removePromises);

//                 }

//                 const syncDuration = Date.now() - syncStartTime;



//                 // Mark as synced for this session
//                 try {
//                     sessionStorage.setItem(syncKey, 'true');
//                 } catch (e) { }

//                 // ⚡ FIX: Reload page if changes were made (better logic - timestamp-based)
//                 const hasChanges = syncedCount > 0 || updatedCount > 0 || removedCount > 0;
//                 if (hasChanges) {
//                     // Use timestamp-based reload prevention instead of simple boolean
//                     // This allows reload after some time has passed (avoid only once per session issue)
//                     const reloadTimestampKey = `${CONFIG.STORAGE_KEYS.CART_SYNCED}_last_reload_time`;
//                     let lastReloadTime = 0;
//                     try {
//                         const stored = sessionStorage.getItem(reloadTimestampKey);
//                         lastReloadTime = stored ? parseInt(stored, 10) : 0;
//                     } catch (e) { }

//                     const now = Date.now();
//                     const timeSinceLastReload = now - lastReloadTime;
//                     const MIN_RELOAD_INTERVAL = 3000; // 3 seconds minimum between reloads

//                     if (timeSinceLastReload > MIN_RELOAD_INTERVAL) {
//                         // Enough time has passed, safe to reload
//                         try {
//                             sessionStorage.setItem(reloadTimestampKey, now.toString());
//                         } catch (e) { }




//                         // ⚡ FIX: Show per-item loaders instead of full page loader
//                         // We only show loaders for items that already exist in the DOM (updates and removes)
//                         const changedVariantIds = [...Object.keys(itemsToUpdate), ...removedVariantIds];
//                         if (changedVariantIds.length > 0) {
//                             this.showItemLoaders(changedVariantIds);
//                         }

//                         this.safelyRefreshCartUI();
//                         return; // Don't continue after refresh
//                     } else {
//                         // Too soon since last reload, just dispatch event

//                         document.dispatchEvent(new CustomEvent('cart:updated'));
//                     }
//                 }

//             } catch (error) {
//                 console.error('[CartSync] Error during cart sync:', error);
//             } finally {
//                 // ⚡ CRITICAL: Always clear syncing flag, even on error
//                 window.__ZYDUS_SYNCING__ = false;

//             }
//         }
//     };

//     // ============================================================================
//     // PUBLIC API
//     // ============================================================================

//     const CartSync = {
//         /**
//          * Initializes the cart sync module
//          */
//         init() {
//             // Wait for DOM to be ready
//             if (document.readyState === 'loading') {
//                 document.addEventListener('DOMContentLoaded', () => this._initialize());
//             } else {
//                 this._initialize();
//             }
//         },

//         /**
//          * Internal initialization
//          */
//         _initialize() {


//             // Initialize all components
//             CartInterceptor.init();
//             WishlistHandler.init();
//             GuestCartLinker.init();


//         },

//         /**
//          * Manually trigger add to cart sync
//          * @param {string|number} variantId - Shopify variant ID
//          * @param {number} quantity - Quantity
//          */
//         addToCart(variantId, quantity = 1) {
//             return ApiClient.sendCartAction('add', variantId, quantity);
//         },

//         /**
//          * Manually trigger update cart sync
//          * @param {string|number} variantId - Shopify variant ID
//          * @param {number} quantity - New quantity
//          */
//         updateCart(variantId, quantity) {
//             return ApiClient.sendCartAction('update', variantId, quantity);
//         },

//         /**
//          * Manually trigger remove from cart sync
//          * @param {string|number} variantId - Shopify variant ID
//          */
//         removeFromCart(variantId) {
//             return ApiClient.sendCartAction('remove', variantId, 0);
//         },

//         /**
//          * Manually trigger add to wishlist sync
//          * @param {string|number} variantId - Shopify variant ID
//          */
//         addToWishlist(variantId) {
//             return ApiClient.sendCartAction('wishlist', variantId, 1);
//         },

//         /**
//          * Manually trigger move to wishlist (remove from cart + add to wishlist)
//          * @param {string|number} variantId - Shopify variant ID
//          */
//         moveToWishlist(variantId) {
//             WishlistHandler.moveFromCartToWishlist(variantId);
//         },

//         /**
//          * Get cart from middleware API
//          */
//         getCart() {
//             return ApiClient.getCart();
//         },

//         /**
//          * Secure remove item from cart
//          * @param {string} sku - Product SKU
//          * @param {string|number} variantId - Shopify variant ID
//          */
//         secureRemove(sku, variantId) {
//             return ApiClient.removeSecure(sku, variantId);
//         },

//         /**
//          * Get browser ID
//          */
//         getBrowserId() {
//             return getBrowserId();
//         },

//         /**
//          * Get session ID
//          */
//         getSessionId() {
//             return getSessionId();
//         },

//         /**
//          * Get customer data
//          */
//         getCustomerData() {
//             return getCustomerData();
//         },

//         /**
//          * Force link guest cart to customer
//          */
//         linkGuestCart() {
//             return GuestCartLinker.linkGuestCart();
//         },

//         /**
//          * Update API base URL (useful for different environments)
//          * @param {string} url - New API base URL
//          */
//         setApiBaseUrl(url) {
//             CONFIG.API_BASE_URL = url;
//         }
//     };

//     // ============================================================================
//     // AUTO-INITIALIZATION
//     // ============================================================================

//     // Expose CartSync globally for manual control if needed
//     window.CartSync = CartSync;

//     // Auto-initialize
//     if (document.readyState === 'loading') {
//         document.addEventListener('DOMContentLoaded', () => CartSync.init());
//     } else {
//         CartSync.init();
//     }

// })();
(function () {
    'use strict';

    if (window.__ZYDUS_CART_SYNC_INITIALIZED__) return;
    window.__ZYDUS_CART_SYNC_INITIALIZED__ = true;
    window.__ZYDUS_SYNCING__ = false;

    // ============================================================================
    // CONFIGURATION
    // ============================================================================
    const CONFIG = {
        API_BASE_URL: 'https://zydus.binaryic.in',
        ENDPOINTS: {
            CART_ACTION:       '/api/cart/action',
            UPDATE_BROWSER_ID: '/api/cart/update-browser-id',
            GET_CART:          '/api/cart/get',
            REMOVE_SECURE:     '/api/cart/remove-secure'
        },
        STORAGE_KEYS: {
            BROWSER_ID:           'zydus_browser_id',
            SESSION_ID:           'zydus_session_id',
            GUEST_LINKED:         'zydus_guest_linked',
            LAST_CUSTOMER_ID:     'zydus_last_customer_id',
            // FIXED: moved from sessionStorage to localStorage so it survives
            // page refreshes. sessionStorage was the core bug — after refresh
            // alreadySynced was always false, triggering Phase 1 which pushed
            // items back to backend that were removed on another device.
            CART_SYNCED:          'zydus_cart_synced',
            SKU_CACHE:            'zydus_sku_cache_',
            LOGOUT_TIMESTAMP:     'zydus_logout_timestamp',
            GUEST_CART_AT_LOGIN:  'zydus_guest_cart_at_login',
            LAST_SYNC_TIME:       'zydus_last_sync_time',
            LAST_LOCAL_MUTATION:  'zydus_last_local_mutation',
            // NEW: stores the last known backend cart state (JSON) in localStorage
            // Used to detect "item existed on backend before, now gone = intentional remove"
            // vs "item never was on backend = guest item to push up"
            LAST_BACKEND_CART:    'zydus_last_backend_cart'
        },
        DEDUP_WINDOW_MS:         1000,
        LOGOUT_SYNC_DELAY_MS:    5000,
        POLL_INTERVAL_MS:        30000,
        MIN_SYNC_INTERVAL_MS:    8000,
        MIN_RELOAD_INTERVAL:     3000,
        // How long after a local mutation before we trust backend removals.
        // Desktop has no local mutation so this is always 0 there — correct behaviour.
        LOCAL_MUTATION_GRACE_MS: 6000,
        RETRY: {
            MAX_ATTEMPTS:  3,
            BASE_DELAY_MS: 1000,
            MAX_DELAY_MS:  10000
        },
        REQUEST_TIMEOUT: 15000,
        DEBOUNCE_DELAY:  300
    };

    // ============================================================================
    // UTILITIES
    // ============================================================================
    function generateUUID() {
        if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r = Math.random() * 16 | 0;
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }

    function getBrowserId() {
        try {
            let id = localStorage.getItem(CONFIG.STORAGE_KEYS.BROWSER_ID);
            if (!id) { id = 'browser_' + generateUUID(); localStorage.setItem(CONFIG.STORAGE_KEYS.BROWSER_ID, id); }
            return id;
        } catch (e) { return 'browser_' + generateUUID(); }
    }

    function getSessionId() {
        try {
            let id = sessionStorage.getItem(CONFIG.STORAGE_KEYS.SESSION_ID);
            if (!id) { id = 'session_' + generateUUID() + '_' + Date.now(); sessionStorage.setItem(CONFIG.STORAGE_KEYS.SESSION_ID, id); }
            return id;
        } catch (e) { return 'session_' + generateUUID() + '_' + Date.now(); }
    }

    function getCustomerData() {
        const c = { id: null, email: null, phone: null, name: null, isLoggedIn: false };
        try {
            if (window.__ZYDUS_CUSTOMER__) {
                const z = window.__ZYDUS_CUSTOMER__;
                c.id = z.id || null; c.email = z.email || null; c.phone = z.phone || null;
                c.name = z.name || ((z.firstName || '') + ' ' + (z.lastName || '')).trim() || null;
                c.isLoggedIn = !!z.id;
                if (c.isLoggedIn) return c;
            }
            if (window.ShopifyAnalytics?.meta?.page?.customerId) { c.id = window.ShopifyAnalytics.meta.page.customerId; c.isLoggedIn = true; }
            if (window.__st?.cid) { c.id = window.__st.cid; c.isLoggedIn = true; }
            const msInput = document.getElementById('ms_customer_id');
            if (msInput?.value && msInput.value !== '0') { c.id = msInput.value; c.isLoggedIn = true; }
            const cMeta = document.querySelector('meta[name="customer-id"]');
            if (cMeta?.content) { c.id = cMeta.content; c.isLoggedIn = true; }
            if (!c.email) {
                if (window.customerEmail) c.email = window.customerEmail;
                const m = document.querySelector('meta[name="customer-email"]'); if (m?.content) c.email = m.content;
            }
            if (!c.phone) {
                if (window.customerPhone) c.phone = window.customerPhone;
                const m = document.querySelector('meta[name="customer-phone"]'); if (m?.content) c.phone = m.content;
            }
            if (!c.name) {
                if (window.customerName) c.name = window.customerName;
                const m = document.querySelector('meta[name="customer-name"]'); if (m?.content) c.name = m.content;
            }
        } catch (e) { console.error('[CartSync] getCustomerData error:', e); }
        return c;
    }

    const delay = ms => new Promise(r => setTimeout(r, ms));

    function getBackoffDelay(attempt) {
        return Math.min(CONFIG.RETRY.BASE_DELAY_MS * Math.pow(2, attempt) + Math.random() * 1000, CONFIG.RETRY.MAX_DELAY_MS);
    }

    function debounce(fn, wait) {
        let t;
        return function (...args) { clearTimeout(t); t = setTimeout(() => fn.apply(this, args), wait); };
    }

    function getDeviceInfo() {
        const ua = navigator.userAgent || '';
        let os = 'Unknown', br = 'Unknown';
        try {
            if      (ua.includes('Windows NT 10'))  os = 'Windows 10/11';
            else if (ua.includes('Windows NT 6.3')) os = 'Windows 8.1';
            else if (ua.includes('Windows NT 6.2')) os = 'Windows 8';
            else if (ua.includes('Windows NT 6.1')) os = 'Windows 7';
            else if (ua.includes('Mac OS X'))  { const m = ua.match(/Mac OS X ([\d_]+)/);  os = 'macOS '   + (m ? m[1].replace(/_/g,'.') : ''); }
            else if (ua.includes('Android'))   { const m = ua.match(/Android ([\d.]+)/);   os = 'Android ' + (m ? m[1] : ''); }
            else if (/iPhone|iPad/.test(ua))   { const m = ua.match(/OS ([\d_]+)/);        os = 'iOS '     + (m ? m[1].replace(/_/g,'.') : ''); }
            else if (ua.includes('Linux'))     os = 'Linux';
            if      (ua.includes('Chrome') && !ua.includes('Edg'))  { const m = ua.match(/Chrome\/([\d.]+)/);  br = 'Chrome '  + (m?m[1]:''); }
            else if (ua.includes('Safari') && !ua.includes('Chrome')){ const m = ua.match(/Version\/([\d.]+)/); br = 'Safari '  + (m?m[1]:''); }
            else if (ua.includes('Firefox'))                          { const m = ua.match(/Firefox\/([\d.]+)/); br = 'Firefox ' + (m?m[1]:''); }
            else if (ua.includes('Edg'))                              { const m = ua.match(/Edg\/([\d.]+)/);     br = 'Edge '    + (m?m[1]:''); }
            br += ua.includes('Mobile') ? ' (Mobile)' : ua.includes('Tablet') ? ' (Tablet)' : ' (Desktop)';
        } catch (e) {}
        return { osVersion: os, deviceDetail: br.trim() };
    }

    function getShopifyCartId() {
        try {
            for (const cookie of document.cookie.split(';')) {
                const [n, v] = cookie.trim().split('=');
                if (n === 'cart' || n === 'cart_token') return decodeURIComponent(v);
            }
            if (typeof Shopify !== 'undefined' && Shopify.cart?.token) return Shopify.cart.token;
        } catch (e) {}
        return '';
    }

    function cacheSKU(vid, sku) {
        if (!sku || !vid) return;
        try { sessionStorage.setItem(CONFIG.STORAGE_KEYS.SKU_CACHE + String(vid), String(sku)); } catch (e) {}
    }

    function getCachedSKU(vid) {
        if (!vid) return '';
        try { return sessionStorage.getItem(CONFIG.STORAGE_KEYS.SKU_CACHE + String(vid)) || ''; } catch (e) { return ''; }
    }

    // ── Dedup ──────────────────────────────────────────────────────────────────
    function isDuplicateCall(action, vid, qty) {
        const key = `${action}_${vid}_${qty}`, now = Date.now();
        if (!window.__ZYDUS_IN_FLIGHT__)  window.__ZYDUS_IN_FLIGHT__  = new Set();
        if (!window.__ZYDUS_LAST_CALLS__) window.__ZYDUS_LAST_CALLS__ = {};
        if (window.__ZYDUS_IN_FLIGHT__.has(key)) return true;
        const last = window.__ZYDUS_LAST_CALLS__[key];
        return !!(last && now - last < CONFIG.DEDUP_WINDOW_MS);
    }
    function markCallStart(action, vid, qty) {
        if (!window.__ZYDUS_IN_FLIGHT__) window.__ZYDUS_IN_FLIGHT__ = new Set();
        window.__ZYDUS_IN_FLIGHT__.add(`${action}_${vid}_${qty}`);
    }
    function markCallEnd(action, vid, qty) {
        const key = `${action}_${vid}_${qty}`;
        window.__ZYDUS_IN_FLIGHT__?.delete(key);
        if (!window.__ZYDUS_LAST_CALLS__) window.__ZYDUS_LAST_CALLS__ = {};
        window.__ZYDUS_LAST_CALLS__[key] = Date.now();
        setTimeout(() => { delete window.__ZYDUS_LAST_CALLS__?.[key]; }, CONFIG.DEDUP_WINDOW_MS + 100);
    }

    // ── Sync throttle (sessionStorage — resets each tab, intentional) ─────────
    function canRunSync() {
        try {
            const last = parseInt(sessionStorage.getItem(CONFIG.STORAGE_KEYS.LAST_SYNC_TIME) || '0', 10);
            return Date.now() - last >= CONFIG.MIN_SYNC_INTERVAL_MS;
        } catch (e) { return true; }
    }
    function markSyncTime() {
        try { sessionStorage.setItem(CONFIG.STORAGE_KEYS.LAST_SYNC_TIME, Date.now().toString()); } catch (e) {}
    }

    // ── Local mutation tracker (sessionStorage — device-local, reset on tab close) ─
    function markLocalMutation() {
        try { sessionStorage.setItem(CONFIG.STORAGE_KEYS.LAST_LOCAL_MUTATION, Date.now().toString()); } catch (e) {}
    }
    function recentLocalMutation() {
        try {
            const ts = parseInt(sessionStorage.getItem(CONFIG.STORAGE_KEYS.LAST_LOCAL_MUTATION) || '0', 10);
            return Date.now() - ts < CONFIG.LOCAL_MUTATION_GRACE_MS;
        } catch (e) { return false; }
    }

    // ── Last backend cart cache (localStorage — survives page refresh) ────────
    // Stores: { customerId: string, items: Map-serialisable array of {vid, qty} }
    // Purpose: lets us distinguish "item never seen on backend" (push up)
    //          from "item was on backend but is now gone" (remove from Shopify).
    function saveLastBackendCart(customerId, backendMap) {
        try {
            const payload = {
                customerId: String(customerId),
                items: Array.from(backendMap.entries()).map(([vid, qty]) => ({ vid, qty }))
            };
            localStorage.setItem(CONFIG.STORAGE_KEYS.LAST_BACKEND_CART, JSON.stringify(payload));
        } catch (e) {}
    }
    function loadLastBackendCart(customerId) {
        try {
            const raw = localStorage.getItem(CONFIG.STORAGE_KEYS.LAST_BACKEND_CART);
            if (!raw) return null;
            const parsed = JSON.parse(raw);
            if (parsed.customerId !== String(customerId)) return null;
            const map = new Map();
            (parsed.items || []).forEach(({ vid, qty }) => map.set(String(vid), Number(qty)));
            return map;
        } catch (e) { return null; }
    }

    // ── alreadySynced: now uses localStorage (survives refresh) ───────────────
    function isAlreadySynced(customerId) {
        try {
            return localStorage.getItem(`${CONFIG.STORAGE_KEYS.CART_SYNCED}_${customerId}`) === 'true';
        } catch (e) { return false; }
    }
    function markAlreadySynced(customerId) {
        try { localStorage.setItem(`${CONFIG.STORAGE_KEYS.CART_SYNCED}_${customerId}`, 'true'); } catch (e) {}
    }

    // ============================================================================
    // API CLIENT
    // ============================================================================
    const ApiClient = {
        async request(endpoint, payload, attempt = 0, options = {}) {
            const url = CONFIG.API_BASE_URL + endpoint;
            const ctrl = new AbortController();
            const tid  = setTimeout(() => ctrl.abort(), CONFIG.REQUEST_TIMEOUT);
            try {
                const res = await fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify(payload),
                    signal: ctrl.signal,
                    mode: 'cors',
                    ...options
                });
                clearTimeout(tid);
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                return { success: true, data: await res.json() };
            } catch (err) {
                clearTimeout(tid);
                if (attempt < CONFIG.RETRY.MAX_ATTEMPTS - 1) {
                    await delay(getBackoffDelay(attempt));
                    return this.request(endpoint, payload, attempt + 1, options);
                }
                console.error('[CartSync] Request failed after retries:', err);
                return { success: false, error: err.message };
            }
        },

        async sendCartAction(action, variantId, quantity, sku = '') {
            const customer = getCustomerData();
            if (!customer.email && !customer.phone)
                return { success: true, data: { skipped: true, reason: 'guest_user' } };
            if (isDuplicateCall(action, variantId, quantity))
                return { success: true, data: { skipped: true, reason: 'duplicate' } };

            markLocalMutation(); // tell sync: don't remove anything for 6 s
            markCallStart(action, variantId, quantity);
            try {
                const di = getDeviceInfo();
                const payload = {
                    email: customer.email || '', mobile: customer.phone || '',
                    action, variant_id: String(variantId), quantity: Number(quantity) || 1,
                    browser_id: getBrowserId(), session_id: getSessionId(),
                    channel: 'web', os_version: di.osVersion, device_detail: di.deviceDetail
                };
                if (sku?.trim())            payload.sku           = sku.trim();
                if (customer.name?.trim())  payload.customer_name = customer.name.trim();
                const cid = getShopifyCartId();
                if (cid?.trim())            payload.shopify_cart_id = cid.trim();

                if (action === 'remove') {
                    const finalSku = sku || getCachedSKU(variantId);
                    this.request(CONFIG.ENDPOINTS.CART_ACTION, payload, 0, { keepalive: true }).catch(() => {});
                    return await this.request(CONFIG.ENDPOINTS.REMOVE_SECURE, {
                        email: payload.email, mobile: payload.mobile,
                        sku: String(finalSku), shopify_variant_id: String(variantId)
                    }, 0, { keepalive: true });
                }
                if (sku && variantId) cacheSKU(variantId, sku);
                return await this.request(CONFIG.ENDPOINTS.CART_ACTION, payload, 0, { keepalive: true });
            } finally {
                markCallEnd(action, variantId, quantity);
            }
        },

        async linkGuestCart() {
            const c = getCustomerData();
            if (!c.isLoggedIn) return { success: false, error: 'Not logged in' };
            return this.request(CONFIG.ENDPOINTS.UPDATE_BROWSER_ID, {
                browserId: getBrowserId(), customername: c.name || '',
                customeremail: c.email || '', customermobileno: c.phone || ''
            }, 0, { keepalive: true });
        },

        async getCart() {
            const c = getCustomerData();
            return this.request(CONFIG.ENDPOINTS.GET_CART,
                { email: c.email || '', mobile: c.phone || '' }, 0, { keepalive: true });
        },

        async removeSecure(sku, variantId) {
            const c = getCustomerData();
            return this.request(CONFIG.ENDPOINTS.REMOVE_SECURE, {
                email: c.email || '', mobile: c.phone || '',
                sku: String(sku), shopify_variant_id: String(variantId)
            }, 0, { keepalive: true });
        }
    };

    // ============================================================================
    // CART INTERCEPTOR
    // ============================================================================
    const CartInterceptor = {
        init() {
            this.interceptFetch();
            this.interceptXHR();
            this.interceptFormSubmissions();
            this.observeCartChanges();
        },

        interceptFetch() {
            const _fetch = window.fetch, self = this;
            window.fetch = async function (input, init) {
                const url = typeof input === 'string' ? input : (input?.url || '');
                const res = await _fetch.apply(this, arguments);
                if (self.isCartEndpoint(url) && !window.__ZYDUS_SYNCING__) {
                    try { self.processCartResponse(url, init, await res.clone().json()); } catch (e) {}
                }
                return res;
            };
        },

        interceptXHR() {
            const self = this, _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
            XMLHttpRequest.prototype.open = function (method, url) {
                this._csUrl = url; this._csMethod = method;
                return _open.apply(this, arguments);
            };
            XMLHttpRequest.prototype.send = function (body) {
                if (self.isCartEndpoint(this._csUrl) && !window.__ZYDUS_SYNCING__) {
                    this._csBody = body;
                    this.addEventListener('load', () => {
                        try { self.processCartResponse(this._csUrl, { method: this._csMethod, body }, JSON.parse(this.responseText)); } catch (e) {}
                    });
                }
                return _send.apply(this, arguments);
            };
        },

        interceptFormSubmissions() {
            document.addEventListener('submit', function (e) {
                const form = e.target;
                if (!form.action || window.__ZYDUS_SYNCING__) return;
                if (!form.action.includes('/cart/add') && !form.action.includes('/cart')) return;
                const fd  = new FormData(form);
                const vid = fd.get('id') || fd.get('variant_id');
                let qty   = parseInt(fd.get('quantity'), 10);
                if (!qty || isNaN(qty)) {
                    const qi = form.querySelector('input[name="quantity"]');
                    qty = qi ? (parseInt(qi.value)||parseInt(qi.getAttribute('min'))||parseInt(qi.dataset.min)||1) : 1;
                }
                qty = Math.max(1, qty);
                let sku = fd.get('sku') || '';
                if (!sku) { const si = form.querySelector('.product-sku,input[name="sku"]'); if (si) sku = si.value || ''; }
                if (!sku) { const qi = form.querySelector('.quantity__input,input[name="quantity"]'); if (qi?.dataset.sku) sku = qi.dataset.sku; }
                if (vid) { if (sku) cacheSKU(vid, sku); ApiClient.sendCartAction('add', vid, qty, sku).catch(console.error); }
            }, true);
        },

        observeCartChanges() {
            const check = debounce(() => this.syncCurrentCart(), CONFIG.DEBOUNCE_DELAY);
            new MutationObserver(mutations => {
                for (const m of mutations) {
                    if (m.type === 'childList') {
                        const t = m.target;
                        if (t.classList && (t.classList.contains('cart-drawer') || t.classList.contains('cart-items') || t.id === 'cart'))
                            check();
                    }
                }
            }).observe(document.body, { childList: true, subtree: true });
        },

        isCartEndpoint(url) {
            if (!url || url.includes('/api/cart/') || url.startsWith(CONFIG.API_BASE_URL)) return false;
            return /\/cart\/(add|update|change|clear)(\.js|\?)/.test(url);
        },

        processCartResponse(url, init, data) {
            if (!data || window.__ZYDUS_SYNCING__) return;
            if      (url.includes('/cart/add'))    this.handleCartAdd(data);
            else if (url.includes('/cart/change') || url.includes('/cart/update')) this.handleCartUpdate(init, data);
            else if (url.includes('/cart/clear'))  this.handleCartClear();
        },

        handleCartAdd(data) {
            const items = data.items || (data.variant_id ? [data] : []);
            items.forEach(item => {
                if (!item?.variant_id) return;
                const sku = item.sku || '', qty = Number(item.quantity) || 1;
                if (sku) cacheSKU(item.variant_id, sku);
                ApiClient.sendCartAction('add', item.variant_id, qty, sku).catch(console.error);
            });
        },

        handleCartUpdate(init, data) {
            try {
                const body = this.parseBody(init);
                if (!Object.keys(body).length) return;
                const { variantId, quantity } = this.extractUpdateInfo(body, data);
                if (!variantId) return;
                const isRemove = this.isRemove(quantity, variantId, data);
                const sku = this.getSKU(variantId, data, isRemove);
                if (!isDuplicateCall(isRemove ? 'remove' : 'update', variantId, quantity))
                    ApiClient.sendCartAction(isRemove ? 'remove' : 'update', variantId, quantity || 0, sku).catch(console.error);
            } catch (e) { console.error('[CartSync] handleCartUpdate error:', e); }
        },

        parseBody(init) {
            let b = {};
            if (!init?.body) return b;
            if (typeof init.body === 'string') {
                const s = init.body.trim();
                if (s.startsWith('{')) { try { b = JSON.parse(s); } catch (e) {} }
                else { const p = new URLSearchParams(s); for (const [k, v] of p) b[k] = v; }
            } else if (init.body instanceof FormData) { for (const [k, v] of init.body) b[k] = v; }
            return b;
        },

        extractUpdateInfo(body, data) {
            let qty = body.quantity !== undefined ? Number(body.quantity) : null, rawId = null, vid = null;
            if (!body.id && !body.line && !body.updates) return { variantId: null, quantity: null };
            if (body.updates && typeof body.updates === 'object') {
                const keys = Object.keys(body.updates);
                if (keys.length) { rawId = keys[0]; qty = Number(body.updates[rawId]); }
            }
            const ln = Number(body.line);
            if (ln > 0 && data?.items?.[ln - 1]) return { variantId: Number(data.items[ln-1].variant_id), quantity: qty };
            if (!rawId && body.id) rawId = body.id;
            if (rawId) { const s = String(rawId); vid = Number(s.includes(':') ? s.split(':')[0] : s); }
            return { variantId: vid, quantity: qty };
        },

        isRemove(qty, vid, data) {
            if (qty === 0) return true;
            if (data?.items && vid) return !data.items.find(i => String(i.variant_id) === String(vid));
            return false;
        },

        getSKU(vid, data, isRemove) {
            let sku = '';
            if (data?.items) { const i = data.items.find(i => String(i.variant_id) === String(vid)); if (i?.sku) { sku = i.sku; cacheSKU(vid, sku); } }
            if (isRemove && !sku) {
                try {
                    const el = document.querySelector(`.select-qty[data-varid="${vid}"][data-sku],[data-variant-id="${vid}"][data-sku],[data-product-id="${vid}"][data-sku]`);
                    if (el?.dataset.sku) { sku = el.dataset.sku; cacheSKU(vid, sku); }
                } catch (e) {}
            }
            if (isRemove && !sku) sku = getCachedSKU(vid);
            return sku;
        },

        handleCartClear() {
            if (window.__ZYDUS_SYNCING__) return;
            fetch('/cart.js').then(r => r.json()).then(cart => {
                (cart.items || []).forEach(i => ApiClient.sendCartAction('remove', i.variant_id, 0));
            }).catch(console.error);
        },

        async syncCurrentCart() {
            try { await (await fetch('/cart.js')).json(); } catch (e) {}
        }
    };

    // ============================================================================
    // WISHLIST HANDLER
    // ============================================================================
    const WishlistHandler = {
        init() {
            document.addEventListener('click', e => {
                const t = e.target.closest('[data-wishlist-add],[data-move-to-wishlist],.add-to-wishlist,.move-to-wishlist');
                if (t) {
                    const vid = t.dataset.variantId || t.dataset.productVariantId || t.closest('[data-variant-id]')?.dataset.variantId;
                    if (vid) this.addToWishlist(vid);
                }
            }, true);
        },
        addToWishlist(vid) { ApiClient.sendCartAction('wishlist', vid, 1); },
        moveFromCartToWishlist(vid) {
            this.addToWishlist(vid);
            fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 0 }) }).catch(console.error);
        }
    };

    // ============================================================================
    // GUEST CART LINKER
    // ============================================================================
    const GuestCartLinker = {

        init() {
            this.checkLoginStatus();
            this.observeLoginChanges();
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible' && getCustomerData().isLoggedIn)
                    this.syncCartFromBackend();
            });
            setInterval(() => { if (getCustomerData().isLoggedIn) this.syncCartFromBackend(); }, CONFIG.POLL_INTERVAL_MS);
        },

        async checkLoginStatus() {
            const c = getCustomerData();
            if (c.isLoggedIn) {
                const lastId    = localStorage.getItem(CONFIG.STORAGE_KEYS.LAST_CUSTOMER_ID);
                const wasLinked = localStorage.getItem(CONFIG.STORAGE_KEYS.GUEST_LINKED);
                if (!wasLinked || lastId !== String(c.id)) {
                    await this._snapshotGuestCart();
                    await this.linkGuestCart();
                    localStorage.setItem(CONFIG.STORAGE_KEYS.LAST_CUSTOMER_ID, c.id);
                    localStorage.setItem(CONFIG.STORAGE_KEYS.GUEST_LINKED, 'true');
                }
                await this.syncCartFromBackend();
            } else {
                if (localStorage.getItem(CONFIG.STORAGE_KEYS.LAST_CUSTOMER_ID)) {
                    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } }).catch(console.error);
                }
                this._clearLoginStorage();
            }
        },

        async _snapshotGuestCart() {
            try {
                const cart = await (await fetch('/cart.js')).json();
                const items = (cart.items || []).map(i => ({ variant_id: String(i.variant_id), quantity: Number(i.quantity)||1, sku: i.sku||'' }));
                sessionStorage.setItem(CONFIG.STORAGE_KEYS.GUEST_CART_AT_LOGIN, JSON.stringify(items));
            } catch (e) { sessionStorage.setItem(CONFIG.STORAGE_KEYS.GUEST_CART_AT_LOGIN, '[]'); }
        },

        _getGuestSnapshot() {
            try { const r = sessionStorage.getItem(CONFIG.STORAGE_KEYS.GUEST_CART_AT_LOGIN); return r ? JSON.parse(r) : null; } catch (e) { return null; }
        },

        observeLoginChanges() {
            let prev = getCustomerData().isLoggedIn;
            setInterval(async () => {
                const now = getCustomerData().isLoggedIn;
                if (now && !prev) {
                    await this._snapshotGuestCart();
                    await this.linkGuestCart();
                    await this.syncCartFromBackend();
                    try { const c = getCustomerData(); localStorage.setItem(CONFIG.STORAGE_KEYS.LAST_CUSTOMER_ID, c.id); localStorage.setItem(CONFIG.STORAGE_KEYS.GUEST_LINKED, 'true'); } catch (e) {}
                } else if (!now && prev) {
                    try { localStorage.setItem(CONFIG.STORAGE_KEYS.LOGOUT_TIMESTAMP, Date.now().toString()); } catch (e) {}
                    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
                        .then(r => { if (r.ok) document.dispatchEvent(new CustomEvent('cart:updated')); }).catch(console.error);
                    this._clearLoginStorage();
                }
                prev = now;
            }, 2000);
        },

        _clearLoginStorage() {
            try {
                [CONFIG.STORAGE_KEYS.GUEST_LINKED, CONFIG.STORAGE_KEYS.LAST_CUSTOMER_ID,
                 CONFIG.STORAGE_KEYS.LAST_BACKEND_CART].forEach(k => localStorage.removeItem(k));
                // Clear all per-customer synced flags
                Object.keys(localStorage).forEach(k => {
                    if (k.startsWith(CONFIG.STORAGE_KEYS.CART_SYNCED)) localStorage.removeItem(k);
                });
                Object.keys(sessionStorage).forEach(k => {
                    if (k.startsWith(CONFIG.STORAGE_KEYS.SKU_CACHE) || k === CONFIG.STORAGE_KEYS.GUEST_CART_AT_LOGIN ||
                        k === CONFIG.STORAGE_KEYS.LAST_SYNC_TIME    || k === CONFIG.STORAGE_KEYS.LAST_LOCAL_MUTATION)
                        sessionStorage.removeItem(k);
                });
            } catch (e) {}
        },

        async linkGuestCart() {
            const result = await ApiClient.linkGuestCart();
            if (!result.success) console.warn('[CartSync] linkGuestCart failed:', result.error);
        },

        safelyRefreshCartUI() {
            if (!window.location.pathname.includes('/cart')) return;
            document.dispatchEvent(new CustomEvent('cart:updated'));
            const el = document.querySelector('cart-items');
            if (el && typeof el.onCartUpdate === 'function') el.onCartUpdate();
            else window.location.reload();
        },

        showItemLoaders(vids) {
            if (!vids?.length || !window.location.pathname.includes('/cart')) return;
            vids.forEach(id => {
                const inp = document.getElementById(`updates_${id}`);
                if (inp) { const loader = inp.closest('.cart-item-main,.cart-item')?.querySelector('.cartLoader'); if (loader) loader.classList.remove('hidden'); }
            });
        },

        // ════════════════════════════════════════════════════════════════════
        //  syncCartFromBackend — REVISED LOGIC
        //
        //  THE THREE-STATE MODEL:
        //
        //  STATE A — First ever sync for this customer (alreadySynced = false,
        //             no lastBackendCart in localStorage):
        //    • Push guest-only Shopify items to backend  (items A, B)
        //    • Pull backend items into Shopify            (item C)
        //    • Do NOT remove anything
        //    • Save backend state to lastBackendCart
        //    • Mark alreadySynced = true (localStorage — survives refresh)
        //
        //  STATE B — Subsequent sync, same session or after refresh
        //            (alreadySynced = true, lastBackendCart exists):
        //    • Items in backend but not in Shopify → ADD to Shopify
        //    • Items in both, different qty        → UPDATE Shopify to backend qty
        //    • Items in Shopify but NOT in backend:
        //        - If item was SEEN in lastBackendCart before → it was intentionally
        //          removed on another device → REMOVE from Shopify ✅
        //        - If item was NEVER in lastBackendCart       → it's a just-added
        //          local item the backend hasn't processed yet → KEEP (push to backend)
        //    • Save new backend state to lastBackendCart
        //
        //  STATE C — Backend empty, alreadySynced = true, lastBackendCart has items:
        //    • Backend was emptied (checkout completed, all items removed remotely)
        //    • Clear Shopify cart
        // ════════════════════════════════════════════════════════════════════
        async syncCartFromBackend() {
            if (!canRunSync() || window.__ZYDUS_SYNCING__) return;
            window.__ZYDUS_SYNCING__ = true;
            markSyncTime();

            try {
                const customer = getCustomerData();
                if (!customer.isLoggedIn) return;

                // Logout-delay guard
                try {
                    const lts = localStorage.getItem(CONFIG.STORAGE_KEYS.LOGOUT_TIMESTAMP);
                    if (lts && Date.now() - Number(lts) < CONFIG.LOGOUT_SYNC_DELAY_MS) {
                        localStorage.removeItem(CONFIG.STORAGE_KEYS.LOGOUT_TIMESTAMP); return;
                    }
                    if (lts) localStorage.removeItem(CONFIG.STORAGE_KEYS.LOGOUT_TIMESTAMP);
                } catch (e) {}

                // In-flight guard
                if (window.__ZYDUS_IN_FLIGHT__?.size > 0) return;
                if (window.__ZYDUS_LAST_CALLS__ && Object.values(window.__ZYDUS_LAST_CALLS__).some(ts => Date.now() - ts < 100)) return;

                // ── Fetch both carts in parallel ──────────────────────────────
                const [backendResult, shopifyRes] = await Promise.all([
                    ApiClient.getCart(),
                    fetch('/cart.js')
                ]);
                if (!backendResult.success) return;

                const backendItems = backendResult.data?.items || [];
                const shopifyCart  = await shopifyRes.json();
                const shopifyItems = shopifyCart.items || [];

                // Build maps
                const backendMap = new Map();
                backendItems.forEach(item => {
                    const vid = String(item.variant_id || item.shopify_variant_id);
                    if (vid) backendMap.set(vid, Number(item.quantity) || 1);
                });

                const shopifyMap = new Map();
                shopifyItems.forEach(item => {
                    shopifyMap.set(String(item.variant_id), { key: item.key, quantity: item.quantity, sku: item.sku || '' });
                });

                const alreadySynced    = isAlreadySynced(customer.id);
                const lastBackendCart  = loadLastBackendCart(customer.id); // null if first sync

                // ── PHASE 1: First sync — merge without removing ──────────────
                if (!alreadySynced) {
                    // Push items that are in Shopify but not in backend
                    // (these are guest items added before login)
                    for (const [vid, data] of shopifyMap.entries()) {
                        if (!backendMap.has(vid)) {
                            try {
                                await ApiClient.sendCartAction('add', vid, data.quantity, data.sku);
                                backendMap.set(vid, data.quantity);
                            } catch (e) { console.error('[CartSync] Phase1 push error:', e); }
                            await delay(150);
                        }
                    }

                    // Now pull everything from (updated) backend into Shopify
                    const p1adds = [], p1updates = {};
                    for (const [vid, backendQty] of backendMap.entries()) {
                        const existing = shopifyMap.get(vid);
                        if (!existing) {
                            p1adds.push({ id: parseInt(vid, 10), quantity: backendQty });
                        } else if (existing.quantity !== backendQty) {
                            // Use max to avoid reducing a qty the user just set
                            p1updates[vid] = Math.max(existing.quantity, backendQty);
                        }
                    }
                    if (p1adds.length) {
                        try {
                            await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: p1adds }) });
                        } catch (e) { console.error('[CartSync] Phase1 add error:', e); }
                    }
                    if (Object.keys(p1updates).length) {
                        try {
                            await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: p1updates }) });
                        } catch (e) { console.error('[CartSync] Phase1 update error:', e); }
                    }

                    saveLastBackendCart(customer.id, backendMap);
                    markAlreadySynced(customer.id);

                    if (p1adds.length || Object.keys(p1updates).length) this.safelyRefreshCartUI();
                    return;
                }

                // ── PHASE 2: Normal sync — backend is source of truth ─────────
                const itemsToAdd    = [];
                const itemsToUpdate = {};
                const itemsToRemove = []; // { key, variantId }
                const itemsToPushUp = []; // Shopify-only items that backend never saw

                // Walk backend → add/update in Shopify
                for (const [vid, backendQty] of backendMap.entries()) {
                    const shopItem = shopifyMap.get(vid);
                    if (shopItem) {
                        if (shopItem.quantity !== backendQty) itemsToUpdate[vid] = backendQty;
                    } else {
                        itemsToAdd.push({ id: parseInt(vid, 10), quantity: backendQty });
                    }
                }

                // Walk Shopify → decide: remove, keep, or push-up
                const gracePeriod = recentLocalMutation();
                for (const [vid, shopItem] of shopifyMap.entries()) {
                    if (backendMap.has(vid)) continue; // handled above

                    const wasOnBackendBefore = lastBackendCart?.has(vid);

                    if (wasOnBackendBefore) {
                        // Item was on backend in the last known state but is gone now.
                        // This means it was deliberately removed on another device.
                        // Remove it from this Shopify cart too — UNLESS we just mutated
                        // locally (grace period), which could mean our own remove is
                        // still in transit.
                        if (!gracePeriod) {
                            itemsToRemove.push({ key: shopItem.key, variantId: vid });
                        }
                        // If in grace period, skip for now — next sync will catch it
                    } else {
                        // Item was NEVER on backend (added on this device very recently,
                        // or backend hasn't processed the add yet).
                        // Push it up so other devices see it.
                        itemsToPushUp.push({ vid, quantity: shopItem.quantity, sku: shopItem.sku });
                    }
                }

                // ── Apply: adds ───────────────────────────────────────────────
                if (itemsToAdd.length) {
                    try {
                        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: itemsToAdd }) });
                        if (!r.ok) { // fallback one-by-one
                            for (const item of itemsToAdd) { try { await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(item) }); await delay(300); } catch (e) {} }
                        }
                    } catch (e) { console.error('[CartSync] Bulk add error:', e); }
                }

                // ── Apply: updates ────────────────────────────────────────────
                if (Object.keys(itemsToUpdate).length) {
                    try {
                        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: itemsToUpdate }) });
                    } catch (e) { console.error('[CartSync] Bulk update error:', e); }
                }

                // ── Apply: removes ────────────────────────────────────────────
                if (itemsToRemove.length) {
                    const removeUpdates = {};
                    itemsToRemove.forEach(({ key }) => { removeUpdates[key] = 0; });
                    try {
                        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: removeUpdates }) });
                    } catch (e) { console.error('[CartSync] Bulk remove error:', e); }
                }

                // ── Push local-only items to backend ──────────────────────────
                for (const item of itemsToPushUp) {
                    try { await ApiClient.sendCartAction('add', item.vid, item.quantity, item.sku); } catch (e) {}
                    await delay(150);
                }

                // Save current backend state for next sync's "was on backend before" check
                saveLastBackendCart(customer.id, backendMap);

                // ── Refresh UI if changed ─────────────────────────────────────
                const hasChanges = itemsToAdd.length || Object.keys(itemsToUpdate).length || itemsToRemove.length;
                if (hasChanges) {
                    const reloadKey = `${CONFIG.STORAGE_KEYS.CART_SYNCED}_last_reload_time`;
                    const lastRel   = parseInt(localStorage.getItem(reloadKey) || '0', 10);
                    const now       = Date.now();
                    if (now - lastRel > CONFIG.MIN_RELOAD_INTERVAL) {
                        try { localStorage.setItem(reloadKey, now.toString()); } catch (e) {}
                        const changedIds = [...Object.keys(itemsToUpdate), ...itemsToRemove.map(i => i.variantId)];
                        if (changedIds.length) this.showItemLoaders(changedIds);
                        this.safelyRefreshCartUI();
                    } else {
                        document.dispatchEvent(new CustomEvent('cart:updated'));
                    }
                }

            } catch (err) {
                console.error('[CartSync] Sync error:', err);
            } finally {
                window.__ZYDUS_SYNCING__ = false;
            }
        }
    };

    // ============================================================================
    // PUBLIC API
    // ============================================================================
    const CartSync = {
        init() {
            if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this._initialize());
            else this._initialize();
        },
        _initialize() { CartInterceptor.init(); WishlistHandler.init(); GuestCartLinker.init(); },
        addToCart(vid, qty = 1)  { return ApiClient.sendCartAction('add',      vid, qty); },
        updateCart(vid, qty)     { return ApiClient.sendCartAction('update',    vid, qty); },
        removeFromCart(vid)      { return ApiClient.sendCartAction('remove',    vid, 0); },
        addToWishlist(vid)       { return ApiClient.sendCartAction('wishlist',  vid, 1); },
        moveToWishlist(vid)      { WishlistHandler.moveFromCartToWishlist(vid); },
        getCart()                { return ApiClient.getCart(); },
        secureRemove(sku, vid)   { return ApiClient.removeSecure(sku, vid); },
        getBrowserId()           { return getBrowserId(); },
        getSessionId()           { return getSessionId(); },
        getCustomerData()        { return getCustomerData(); },
        linkGuestCart()          { return GuestCartLinker.linkGuestCart(); },
        setApiBaseUrl(url)       { CONFIG.API_BASE_URL = url; }
    };

    window.CartSync = CartSync;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => CartSync.init());
    else CartSync.init();
})();
